
import { ref } from "vue";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { Options, Vue } from "vue-class-component";
import { compare, dateConversion, getLocalProject } from "@/utils";
import * as echarts from "echarts";
// import { Chart } from "highcharts-vue";
import { ElMessage } from "element-plus";
import { dispatchGetDeepPerformanceSelectOptions } from "@/store/performance/actions";
import {
  dispatchDeepPerformanceCpuLabels,
  dispatchDeepPerformanceCpuCpuThreads,
  dispatchDeepPerformanceCpuCpuTrend,
  dispatchDeepPerformanceCpuCpuVersions,
  dispatchDeepPerformanceCpuCpuVersionsOld,
  dispatchDeepPerformanceCpuLabelsOld,
  dispatchDeepPerformanceFlameGraphUrl,
  dispatchDeepPerformanceTrendNode,
  dispatchDeepPerformanceCpuCpuSoTrend,
  dispatchDeepPerformanceCpuCpuFunction,
  dispatchDeepPerformanceCpuCpuByFrame,
  dispatchDeepPerformanceCpuStack,
  dispatchDeepPerformanceCpuStackMerge,
  dispatchDeepPerformanceCpuStackFind,
  dispatchDeepPerformanceCpuFunctionCos,
  dispatchDeepPerformanceCpuFunctionModel,
  dispatchDeepPerformanceCpuFunctionModuleTrend,
  dispatchGetDeepPerformanceSelectOptionsOld,
  dispatchGetDeepPerformanceSelectOptionsLast,
  dispatchDeepPerformanceCpuDetail,
  dispatchDeepPerformanceCpuUsageTrend,
  dispatchGetDeepPerformancePageList,
  dispatchDeepPerformanceCpuPutDetail,
  actionDeepPerformanceCpuPutCheck,
  dispatcDeepPerformanceCpuPutConfig,
  dispatchDeepPerformanceCpuCpuFunctionOverview,
  dispatchDeepPerformanceCpuStackCreatedOld,
  dispatchDeepPerformanceCpuUsageList,
  dispatcDeepPerformanceCpufuncTrend,
  dispatchDeepPerformanceCpuCpuConfig,
  dispatchDeepPerformancefuncList,
  dispatchDeepPerformanceCpuCpuConfigSoList,
  dispatchGetPerformancePageListSummary,
} from "@/store/performance/actions";
import {
  readDeepPerformanceSelectOptions,
  readDeepPerformanceSelectOptionsOld,
  readDeepPerformanceSelectOptionsLast,
} from "@/store/performance/getters";
import { store } from "@/store";
import {
  readGetdeepCpuUsageTrend,
  readGetdeepCpuLabels,
  readGetdeepCpuLabelsOld,
  readGetdeepCpuThreads,
  readGetdeepCpuFuncTrend,
  readDeepPerformancePageList,
  readPerformancePageListSummary,
  readGetdeepCpuTrend,
  readGetdeepFlameUrl,
  readGetdeepfuncList,
  readGetdeepCpuSoTrend,
  readGetdeepCpuVersions,
  readGetdeepCpuVersionsOld,
  readGetdeepCpuFunctionOverview,
  readGetdeepCpuFunction,
  readGetdeepCpuByFrame,
  readGetdeepCpuStack,
  readGetdeepCpuStackFind,
  readGetdeepTrendNode,
  readGetdeepCpuFunctionModel,
  readGetdeepCpuFunctionCos,
  readGetdeepCpuModuleTrend,
  readGetdeepCpuDetail,
  readGetdeepCpuCheck,
  readGetdeepCpuUsageList,
  readGetdeepCpuConfig,
  readGetdeepCpuConfigSoList,
  readGetdeepCpuStackCreatOld,
  readGetdeepCpuStackCreat,
} from "@/store/performance/getters"; //引入仓库接口

import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { readUserProfile } from "@/store/main/getters";
import {
  readMyProjects,
  readProjectDetail,
  readProjectScenes,
} from "@/store/project/getters";
import {
  dispatchGetProjectScenes,
  dispatchGetProjectDetail,
  dispatchGetMyProjects,
  dispatchUpdateProject,
} from "@/store/project/actions";

import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import { config } from "@fullcalendar/core/internal";

export default class ProjectOverview extends Vue {
  public localProject = Number(getLocalProject());
  public state2 = "";
  public restaurants = {
    value: "",
    link: "",
  };
  public get func_list() {
    return readGetdeepfuncList(store);
  }
  public get so_list() {
    return readGetdeepCpuConfigSoList(store);
  }
  public clear(row, i) {
    if (row.edit == true) {
      row.edit = false;
    } else {
      this.conFig.module_list.splice(i, 1);
      this.conFig.is_show_function = this.conFig.is_show_function_check ? 0 : 1;
    }
  }
  public get thread_add() {
    return Object.keys(this.so_list);
  }
  public setting: any = {};
  public async addRow() {
    this.addShow = true;
    let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);

    await dispatchDeepPerformanceCpuCpuConfigSoList(store, {
      project: this.localProject,
      id_test: this.dataConsumeOptions.id_test,
    });
  }
  public get parentList() {
    let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);

    let list = [];
    if (this.localProject !== 7) {
      for (let i in report_settings.module) {
        if (i !== "is_show_all" && i !== "is_show_function") {
          for (let n in report_settings.module[i]) {
            for (let m in report_settings.module[i][n]) {
              list.push(m);
            }
          }
        }
      }
    } else {
      for (let i in report_settings.module) {
        if (i !== "is_show_all" && i !== "is_show_function") {
          for (let n in report_settings.module[i]) {
            list.push(n);
          }
        }
      }
    }

    return list;
  }
  public async addList() {
    if (this.localProject != 7) {
      this.conFig.module_list.push({
        thread: this.add_row_data.thread,
        so: this.add_row_data.so,
        module: this.add_row_data.moudel,
        parent: this.add_row_data.parent,
        functions: this.add_row_data.functions_string.split("\n"),
        func: this.add_row_data.func_check ? 1 : 0,
        show: this.add_row_data.show_check ? 1 : 0,
        show_trend: this.add_row_data.trend_check ? 1 : 0,
      });
    } else {
      this.conFig.module_list.push({
        thread: this.add_row_data.thread,

        module: this.add_row_data.moudel,
        parent: this.add_row_data.parent,
        functions: this.add_row_data.functions_string.split("\n"),
        func: this.add_row_data.func_check ? 1 : 0,
        show: this.add_row_data.show_check ? 1 : 0,
        show_trend: this.add_row_data.trend_check ? 1 : 0,
      });
    }

    this.addShow = false;
  }
  public async submit_edit() {
    this.tableAddShow = false;

    this.conFig.is_show_function = this.conFig.is_show_function_check ? 0 : 1;
    this.conFig.module_list.forEach((v) => {
      v.edit = false;
      v.func = v.func_check ? 1 : 0;
      v.show = v.show_check ? 1 : 0;
      v.show_trend = v.trend_check ? 1 : 0;
      v.functions = v.functions_string.split("\n");
    });
    let b = (this as any).$message({
      //Message 消息提示
      message: "正在更新模块,请稍等",
      showClose: true,
      duration: 0,
    });

    await dispatcDeepPerformanceCpuPutConfig(store, {
      project: this.localProject,
      id_test: this.dataConsumeOptions.id_test,
      module_config: this.conFig,
    });
    b.close();
    ElMessage.success({
      message: "保存成功",
      showClose: true,
      type: "success",
    });
    await dispatchDeepPerformanceCpuDetail(store, {
      project: this.localProject,
      id_test: this.dataConsumeOptions.id_test,
    });
    let date = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;
    let date1 = this.versionsOptions.filter(
      (v) => v.chinese == this.trendDataOptions.version
    )[0].date;

    let version = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    let old_date = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].date;
    let old_version = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].game_version;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.dataOptions.pick !== null) {
      startTimeAll = dateConversion(this.dataOptions.pick[0]);
      endTimeAll = dateConversion(this.dataOptions.pick[1]);
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.dataOptions.pick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }
    await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
      project: this.localProject,
      start: startTimeAll,
      end: endTimeAll,
      device_id: Number(this.dataOptions.device),
      scene_id: Number(this.dataOptions.scene),

      label: this.dataOptions.subScene,

      id_test: this.dataConsumeOptions.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    this.drawMoTrend();
    await dispatchDeepPerformanceCpuCpuFunction(store, {
      project: this.localProject,
      date: date,
      old_date: old_date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      old_version: old_version,
      id_test: this.id_test,
      thread: this.dataConsumeOptions.thread,
      label: this.dataConsumeOptions.subScene,
      old_test: old_test,
    });
  }
  public submit_cancellation() {
    dispatchDeepPerformanceCpuCpuConfig(store, {
      project: this.localProject,
    });

    ElMessage.success({
      message: "数据已还原",
      showClose: true,
      type: "success",
    });
    this.addShow = false;

    this.tableAddShow = false;
  }
  public edit(row) {
    row.edit = !row.edit;

    if (row.edit == false) {
      row.func = row.func_check ? 1 : 0;
      row.show = row.show_check ? 1 : 0;
      row.show_trend = row.trend_check ? 1 : 0;
      row.functions = row.functions_string.split("\n");

      this.conFig.is_show_function = this.conFig.is_show_function_check ? 0 : 1;
    }
  }
  public get conFig() {
    let list = readGetdeepCpuConfig(store);

    list.is_show_function_check = list.is_show_function == 1 ? false : true;
    list.module_list.forEach((v) => {
      if (v.func == 1) {
        v.func_check = true;
      } else {
        v.func_check = false;
      }
      if (v.show_trend == 1) {
        v.trend_check = true;
      } else {
        v.trend_check = false;
      }
      if (v.show) {
        v.show_check = true;
      } else {
        v.show_check = false;
      }
      v.edit = false;
      v.functions_string = v.functions.join("\n");
    });
    return list;
  }
  public activeNames = [];
  public ojb = {
    children: [],
    depth: 0,
    event_count: 1,
    frameIndex: 1,
    frameTime: 250.54,
    func_hash_id: 1,
    id: "0",
    id_row: 0,
    is_exists: 0,
    is_leaf: false,
    lib_so_eventcount: 1,
    name: "FrameTime",
    parent_id: 0,
    process_eventcount: 1,
    rate: 100,
    thread_eventcount: 1,
    thread_hash_id: 1,
    value: 0,
  };
  public get treeData() {
    let list = [];
    list = [
      {
        label: "CPU性能分析",
        children: [
          {
            label: "性能趋势",
          },

          {
            label: "详细数据",
          },
          {
            label: "主要模块耗时",
          },
          {
            label: "函数耗时",
          },
        ],
      },
    ];
    // if (this.localProject === 12) {
    //   list = [
    //     {
    //       label: "CPU性能分析",
    //       children: [
    //         {
    //           label: "性能趋势",
    //         },

    //         {
    //           label: "详细数据",
    //         },

    //         {
    //           label: "函数耗时",
    //         },
    //       ],
    //     },
    //   ];
    // }
    return list;
  }
  public dialogFormVisible1 = false;
  public custom_json = "";
  public sort_change(column) {
    let form: any = {};

    this.currentPage = 1;

    if (this.serch != "") {
      this.input_list.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );
      this.tableList_new = this.input_list.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
      this.total = this.input_list.length;
    } else {
      this.tableList.sort(
        this.sortFun(column?.prop, column?.order === "ascending")
      );

      this.tableList_new = this.tableList.slice(0, 10);
    }
  }
  public updateCheckProperty(obj, idArray) {
    if (obj.id) {
      obj.check = idArray.some((item) => item.name === obj.name);
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.updateCheckProperty(child, idArray);
      });
    }
  }
  public updateCheckById(obj, name, value) {
    if (obj.name && obj.name === name) {
      obj.check = value;
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.updateCheckById(child, name, value);
      });
    }
  }
  public toggleCheckByName(obj, name) {
    if (obj.name && obj.name === name) {
      obj.check = !obj.check;
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.toggleCheckByName(child, name);
      });
    }
  }

  public async look(row) {
    this.stackData_all.forEach((item) => {
      this.toggleCheckByName(item, row.name);
    });
    if (row.check) {
      this.tableList.forEach((v) => {
        if (v.name === row.name) {
          v.check = true;
        }
      });
      await dispatchDeepPerformanceTrendNode(store, {
        project: this.localProject,
        id_test: this.dataConsumeOptions.id_test,
        node_id: row.id,
      });
      this.series_list.push({
        name: row.name,
        type: "line",

        showSymbol: false,
        id: row.id,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        data: this.ratelist.map((item) => (item === null ? 0 : item)),
      });
    } else {
      this.tableList.forEach((v) => {
        if (v.name === row.name) {
          v.check = false;
        }
      });
      let target_index = this.series_list.findIndex((v) => v.name == row.name);
      this.series_list.splice(target_index, 1);
    }
    this.selectData(this.trendInex);
    this.drawAnalyseTrend();
  }
  sortFun(attr, rev) {
    if (rev == undefined) {
      rev = 1;
    } else {
      rev = rev ? 1 : -1;
    }
    return (a, b) => {
      a = a[attr];
      b = b[attr];

      return this.customSort(a, b, rev);
    };
  }
  customSort(a, b, rev) {
    if (a === undefined || a === "-") {
      return rev === 1 ? 1 : -1;
    } else if (b === undefined || b === "-") {
      return rev === 1 ? -1 : 1;
    } else {
      return (a - b) * rev;
    }
  }
  //   public  loadAll =
  //    [
  //     { value: 'vue', label: 'https://github.com/vuejs/vue' },
  //     { value: 'element', label: 'https://github.com/ElemeFE/element' },
  //     { value: 'cooking', label: 'https://github.com/ElemeFE/cooking' },
  //     { value: 'mint-ui', label: 'https://github.com/ElemeFE/mint-ui' },
  //     { value: 'vuex', label: 'https://github.com/vuejs/vuex' },
  //     { value: 'vue-router', label: 'https://github.com/vuejs/vue-router' },
  //     { value: 'babel', label: 'https://github.com/babel/babel' },
  //   ]

  // public a(queryString: string, cb: any){
  //   console.log(queryString)
  //   console.log(cb)
  //   console.log(queryString)
  //  let results =queryString?this.loadAll.filter(this.createFilter(queryString)):this.loadAll
  //  console.log(results)
  //  cb(results)
  // }
  // public createFilter(queryString){
  // return (restaurant) => {
  //   console.log(restaurant)
  // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
  // };
  // }
  public get cpu_usage_data() {
    return readGetdeepCpuUsageList(store).data;
  }
  public dataOptions = {
    pick: [],
    scene: "",
    device: "",
    subScene: "",
    thread: [],
  };
  public trendData = {
    pick: [],
    scene: "",
    device: "",
    subScene: "",
    thread: [],
  };
  public moduleLoading = false;
  public soTrendLoading = false;
  public cpuTrendLoading = false;
  public disposeOptions = {
    thread: [],
    so: [],
    module: [],
    thread_threshold: "10%",
    so_threshold: "10%",
    module_threshold: "10%",

    module_list: {},
  };
  public leftBtn(item) {
    if (this.pictureArr.length != 0) {
      let boxWidth = document.getElementById(
        this.pictureArr[0].time + this.pictureArr[0].img
      ).offsetWidth;
      let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

      this.pictureArr.forEach(function (v) {
        //
        v.ofwidth = ofwidth -= boxWidth + 10;
        //
        //
      });
      let i = 0;

      this.pictureArr.forEach((v, index) => {
        if (v.img === item) {
          i = index;
        }
      });

      if (i - 1 >= 0) {
        let file1 = "";
        file1 = this.pictureArr[i - 1].ofwidth + "px";
        document.getElementById(
          "scro"
        ).style.transform = `translateX(${file1})`;
        (document.getElementById(
          this.pictureArr[i - 1].time + this.pictureArr[i - 1].img
        ).firstChild as any).style.outline = "6px solid #4271fb";
        var siblings = this.sibling(
          document.getElementById(
            this.pictureArr[i - 1].time + this.pictureArr[i - 1].img
          )
        );
        siblings.forEach(function (v) {
          //
          v.firstChild.style.outline = 0;
        });
        this.maskImg.img = this.pictureArr[i - 1].img;
      }
    }
  }
  public rightBtn1(item) {
    if (this.pictureArr.length != 0) {
      let boxWidth = document.getElementById(
        this.pictureArr[0].time + this.pictureArr[0].img
      ).offsetWidth;
      let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

      this.pictureArr.forEach(function (v) {
        //
        v.ofwidth = ofwidth -= boxWidth + 10;
        //
        //
      });
      let i = 0;

      this.pictureArr.forEach((v, index) => {
        if (v.img === item) {
          i = index;
        }
      });

      if (i + 1 <= this.pictureArr?.length) {
        let file1 = "";
        file1 = this.pictureArr[i + 1].ofwidth + "px";
        document.getElementById(
          "scro"
        ).style.transform = `translateX(${file1})`;
        (document.getElementById(
          this.pictureArr[i + 1].time + this.pictureArr[i + 1].img
        ).firstChild as any).style.outline = "6px solid #4271fb";
        var siblings = this.sibling(
          document.getElementById(
            this.pictureArr[i + 1].time + this.pictureArr[i + 1].img
          )
        );
        siblings.forEach(function (v) {
          //
          v.firstChild.style.outline = 0;
        });
        this.maskImg.img = this.pictureArr[i + 1].img;
      }
    }
  }
  public drawHistory() {
    let performance_line: any = document.getElementById("history_trend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.historyData.date_list,
      },

      series: {
        name: this.historyData.func_name,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.historyData.value[0],
      },
    });
  }
  public async view_trend(name) {
    this.historyShow = true;
    await dispatcDeepPerformanceCpufuncTrend(store, {
      project: this.localProject,
      name: name,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
      device_id: this.trendDataOptions.device,
      scene_id: this.trendDataOptions.scene,
    });
    this.drawHistory();
  }
  public get historyData() {
    return readGetdeepCpuFuncTrend(store);
  }
  public overList = [];
  public overviewHead() {
    if (readGetdeepCpuFunctionOverview(store).length != 0) {
      this.overList = Object.keys(
        readGetdeepCpuFunctionOverview(store)[0]?.new
      );
    }
  }
  public get overviewData() {
    return readGetdeepCpuFunctionOverview(store);
  }
  public state = false;
  public async close1(arr, state) {
    arr.forEach((v) => {
      (this.$refs.table as any).toggleRowExpansion(v, state);
      if (document.getElementById(v?.id) != null) {
        document.getElementById(v?.id).style.color = "#fff";
      }
      if (v.children) {
        //  回调函数 重复关闭
        this.close1(v.children, state);
      }
    });
    this.isExpand = false;
  }
  public isExpand = false;
  public cpu_function_cos_list = [];
  public cpu_function_model_list = [];
  public cpu_function_thread_list = [];
  public cpu_function_thread_list1 = [];
  public get cpu_function_cos() {
    return readGetdeepCpuFunctionCos(store).data;
  }
  public get cpu_function_model() {
    this.cpu_function_model_list = readGetdeepCpuFunctionModel(store).data;

    return this.cpu_function_model_list;
  }
  public get detail() {
    return readGetdeepCpuDetail(store);
  }
  public num = -1;
  public gradient(startColor, endColor, step) {
    // 将 hex 转换为rgb
    var sColor = this.hexToRgb(startColor),
      eColor = this.hexToRgb(endColor);

    // 计算R\G\B每一步的差值
    var rStep = (eColor[0] - sColor[0]) / step;
    var gStep = (eColor[1] - sColor[1]) / step;
    var bStep = (eColor[2] - sColor[2]) / step;

    var gradientColorArr = [];
    for (var i = 0; i < step; i++) {
      // 计算每一步的hex值
      gradientColorArr.push(
        this.rgbToHex(
          parseInt(rStep * i + sColor[0]),
          parseInt(gStep * i + sColor[1]),
          parseInt(bStep * i + sColor[2])
        )
      );
    }
    return gradientColorArr;
  }
  public hexToRgb(hex) {
    var rgb = [];
    for (var i = 1; i < 7; i += 2) {
      rgb.push(parseInt("0x" + hex.slice(i, i + 2)));
    }
    return rgb;
  }
  public rgbToHex(r: any, g: any, b: any) {
    var hex = ((r << 16) | (g << 8) | b).toString(16);
    return "#" + new Array(Math.abs(hex.length - 7)).join("0") + hex;
  }
  public list1 = [];
  public tableRowClassName(row: any) {
    let num = Math.round(row.row.value);
    var startColor = "#3E3E3E";
    var endColor = "#6E2F2F";
    var colorArr = this.gradient(
      startColor,
      endColor,
      Math.round(this.stackData[0].value)
    );
    if (num == Math.round(this.stackData[0].value)) {
      num = Math.round(this.stackData[0].value) - 1;
    }

    // console.log(colorArr[num])
    return {
      background: colorArr[num],
      borderBottom: "0",
      color: "#fff",
      height: "2px",
    };
  }
  public getTableColor(item) {
    let startColor = "#62CDFF";
    let endColor = "#E9F8F9";

    var colorArr = this.gradient(startColor, endColor, 6);
    colorArr = ["	#00BFFF", "#62CDFF", "#97DEFF", "#C9EEFF", "#E9F8F9"];

    return colorArr[item];
  }
  public report_settings_threshold: any = {};
  public report_settings_threshold_abs = {};
  public com_num_color(item, item2, type, check) {
    if (type) {
      if (typeof item == "number" && typeof item2 == "number") {
        if (check == true) {
          if (
            Math.abs(item - item2) / item2 >
            this.report_settings_threshold[type]
          ) {
            if (item > item2) {
              return "red";
            }
            if (item < item2) {
              return "#00b050";
            }
          }
        } else {
          if (
            Math.abs(item - item2) >
            this.report_settings_threshold[type] * 100
          ) {
            if (item > item2) {
              return "red";
            }
            if (item < item2) {
              return "#00b050";
            }
          }
        }
      }
    }
  }
  public com_num_color1(item, item2, type, i) {
    if (type) {
      if (typeof item == "number" && typeof item2 == "number") {
        if (
          Math.abs(item - item2) / item2 >
          this.report_settings_threshold[type]
        ) {
          if (item > item2) {
            if (i === "FPS") {
              return "#00b050";
            } else {
              return "red";
            }
          }
          if (item < item2) {
            if (i === "FPS") {
              return "red";
            } else {
              return "#00b050";
            }
          }
        } else {
          return "#606266";
        }
      }
    }
  }
  public month = 1;
  // public async load(
  //   row: any,
  //   treeNode: unknown,
  //   resolve: (date: any[]) => void
  // ) {
  //   await dispatchDeepPerformanceCpuStackCreatedOld(store,{
  //       project: this.localProject,
  //     id_test: Number(readGetdeepCpuByFrame(store).id_test),
  //     frame: this.abs_time,
  //     depth:row.depth,
  //     id_row:row.id_row,
  //     thread:row.thread_hash_id,
  //     abs_time:this.month,
  //   })
  //    let childrenListArray = readGetdeepCpuStackCreatOld(store);
  //      await setTimeout(() => {
  //     resolve(childrenListArray?.func_list?.new);
  //   }, 1000);
  // }
  // public get stackData() {

  //   return readGetdeepCpuStackCreat(store)?.func_list?.new

  // }
  public get stackData() {
    let list = [];
    let list1 = [];

    if (JSON.stringify(readGetdeepCpuStack(store)) != "{}") {
      list.push({});
      list[0] = JSON.parse(JSON.stringify(readGetdeepCpuStack(store)));

      list.forEach((v) => {
        if (v.children.length > 0) {
          v.is_expand = true;
        } else {
          v.is_expand = false;
        }
      });
      list.map((e) => {
        delete e.children;
      });
      // list[0].is_expand=true
      list1.push(readGetdeepCpuStack(store));
      // list.push({})
    }

    return list;
  }
  public stackData_all = [];
  public stack_data(data) {
    let list = [];
    list.push({});
    list[0] = JSON.parse(JSON.stringify(data));
    list.forEach((item) => {
      this.addCheckProperty(item);
    });

    return list;
  }
  public addCheckProperty(obj) {
    if (obj.id) {
      obj.check = false;
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.addCheckProperty(child);
      });
    }
  }
  public get stackData_obj() {
    let list = {};

    if (JSON.stringify(readGetdeepCpuStack(store)) != "{}") {
      list = readGetdeepCpuStack(store);

      // list.push({})
    }

    return list;
  }
  public colList = [
    "rgba(237, 86, 100)",
    "rgba(145, 124, 190)",
    "rgba(94, 190, 181)",
    "rgba(237, 131, 92)",
    "rgba(102, 132, 213)",
    "rgba(250, 203, 97)",
    "rgba(59, 162, 114)",
    "rgba(102, 132, 213)",
    "rgba(53, 166, 159)",
    "rgba(250, 203, 97)",
    "rgba(237, 86, 100)",
    "rgba(145, 124, 190)",
    "rgba(94, 190, 181)",
    "rgba(237, 131, 92)",
    "rgba(102, 132, 213)",
    "rgba(250, 203, 97)",
    "rgba(59, 162, 114)",
    "rgba(102, 132, 213)",
    "rgba(53, 166, 159)",
    "rgba(250, 203, 97)",
  ];
  public series() {
    this.series_list = [];
    let list = Object.keys(this.cpu_by_frame?.thread_list);

    list.forEach((v, index) => {
      this.series_list.push({
        name: v,
        type: "line",

        showSymbol: false,

        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        id: this.cpu_by_frame?.thread_list[v],
        data: this.cpu_by_frame?.series[index],
      });
    });

    return this.series_list;
  }
  public legend_data = {};
  public updateSelected(c, d) {
    // 遍历第二个数组中的每个对象
    Object.keys(d).forEach(function (key) {
      // 在第一个数组中查找是否存在相同的 name 字段的对象
      c.forEach(function (item1) {
        if (item1.name == key) {
          item1.selected = d[key] ? true : false;
        }
      });
    });
    return c;
  }
  public legendData() {
    this.legend_data = {};
    let list = Object.keys(this.cpu_by_frame?.thread_list);

    list.forEach((v, index) => {
      this.legend_data[v] = true;
    });

    return this.legend_data;
  }

  public get series_creat() {
    let list = [];
    this.cpu_by_frame?.thread_list.forEach((v, index) => {
      if (this.localProject === 34) {
        if (
          v === "FrameTime" ||
          v === "UnityMain" ||
          v === "CoreThread" ||
          v === "UnityGfx" ||
          v === "NativeThread" ||
          v === "Worker Thread"
        ) {
          list.push({
            name: v,
            type: "line",

            showSymbol: false,

            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1,
                },
              },
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
            },
            yAxisIndex: 0,
            data: this.cpu_by_frame?.series[index],
          });
        }
      } else {
        if (v === "FrameTime" || v === "GameThread" || v === "RenderThread") {
          list.push({
            name: v,
            type: "line",

            showSymbol: false,

            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1,
                },
              },
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
            },
            yAxisIndex: 0,
            data: this.cpu_by_frame?.series[index],
          });
        }
      }
    });
    return list;
  }
  public startValue = 0;
  public endValue = 100;
  public coordRange = [];
  public selectShow = true;
  public selectList = [];
  public selectStart = 0;
  public selectEnd = 0;
  public func_name = "";
  public func_rate = "";
  public flame_serch = "";
  public frame_merge_size = 10;
  public tableList_new = [];
  public serch = "";
  public currentPage = 1;
  public total = 1;
  public tableList = [];
  public makLineShow = true;
  public framesInfo = {
    framesCount: 0,
    start: 0,
    end: 0,
    sumTime: 0,
    FPS: 0,

    ratelist: [],
    frameTime: 0,
  };
  public framesInfo_all = {
    framesCount: 0,
    sumTime: 0,
    FPS: 0,
    frameTime: 0,
  };

  public trendIndex = 0;
  public series_list = [];
  public selectData(item?) {
    let list = [];
    this.selectList = [];
    if (this.coordRange.length > 0) {
      this.selectStart = this.coordRange[0];
      this.selectEnd = this.coordRange[1];
      this.series_list.forEach((v) => {
        //   let num=0
        //   console.log( v.data.filter((i,index)=>index>=this.coordRange[0]&&index<=this.coordRange[1]))
        //  v.data.filter(i=>i>=this.coordRange[0]&&i<=this.coordRange[1]).forEach(k=>{
        //   num+=k

        //  })
        //   console.log(num)
        list.push({
          name: v.name,
          value: v.data.filter(
            (i, index) =>
              index >= this.coordRange[0] && index <= this.coordRange[1]
          ),
        });
      });
    } else {
      this.series_list.forEach((v) => {
        //   let num=0
        //   console.log( v.data.filter((i,index)=>index>=this.coordRange[0]&&index<=this.coordRange[1]))
        //  v.data.filter(i=>i>=this.coordRange[0]&&i<=this.coordRange[1]).forEach(k=>{
        //   num+=k

        //  })

        list.push({
          name: v.name,
          value: v.data.filter((i, index) => index == item),
        });
      });
    }

    this.selectList = list.map((obj) => ({
      name: obj.name,
      sum: obj.value.reduce((acc, cur) => acc + cur, 0) / obj.value.length,
    }));
  }
  public calculateAverage(arr) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
    return sum / arr.length;
  }
  public calculateSum(arr) {
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
    return sum;
  }
  public overall() {
    let frameTimeList = this.cpu_by_frame.series[0].slice(
      0,
      this.cpu_by_frame.series[0].length
    );
    this.framesInfo_all.framesCount = frameTimeList.length;
    (this.framesInfo_all.sumTime as any) = this.calculateSum(
      frameTimeList
    ).toFixed(2);
    let frameTime = this.calculateAverage(frameTimeList);

    (this.framesInfo_all.FPS as any) = (1000 / frameTime).toFixed(2);
    (this.framesInfo_all.frameTime as any) = frameTime.toFixed(2);
  }
  public getFramesInfo(start, end) {
    let frameTimeList = this.cpu_by_frame.series[0].slice(start, end + 1);

    let frameTime = this.calculateAverage(frameTimeList);

    this.framesInfo.start = start;
    this.framesInfo.end = end;
    this.framesInfo.framesCount = frameTimeList.length;

    (this.framesInfo.sumTime as any) = this.calculateSum(frameTimeList).toFixed(
      2
    );
    (this.framesInfo.FPS as any) = (1000 / frameTime).toFixed(2);
    (this.framesInfo.frameTime as any) = frameTime.toFixed(2);
  }
  public get allColorList() {
    let list = [];
    for (let i = 0; i < 3; i++) {
      this.colList.forEach((v) => {
        list.push(v);
      });
    }
    return list;
  }
  public rightBtn = false;
  public innerwidth = "";
  public trans_time = "";
  public flag = true;
  public maskBtn(ev) {
    if (!(this.$refs.mask as any).contains(ev.target)) {
      this.showMask = false;
      this.closePictureBtn = false;
    }
  }
  public pictureSwitch() {
    if (this.flag) {
      this.innerwidth = "calc(100% - 200px)";
      this.trans_time = 1 + "s";
      this.flag = false;
    } else {
      this.innerwidth = 40 + "px";
      this.flag = true;
    }
  }
  public threadLoading = false;
  public soLoading = false;
  public functionNameLoading = false;
  public functionNameTrend = false;
  public functionStack = false;
  public functionStack1 = false;
  public visible = true;
  public soTrendShow = false;
  public dataConsumeOptions = {
    version: "",
    device: "",
    scene: "",
    old_verson: "",
    id_test: "",
    thread: "",
    subScene: "",
    old_test: "",
  };
  public add_row_data = {
    thread: "",
    so: "",
    moudel: "",
    parent: "",
    func_check: false,
    functions_string: "",
    show_check: false,
    trend_check: false,
  };
  public trendDataOptions = {
    version: "",
    device: "",
    scene: "",
  };
  public depth(num) {
    return num * 10;
  }
  public get performace_select_options() {
    const options = readDeepPerformanceSelectOptions(store);

    return options;
  }
  public get performace_select_options_old() {
    const options = readDeepPerformanceSelectOptionsOld(store);

    return options;
  }

  public get performace_select_options_last() {
    const options = readDeepPerformanceSelectOptionsLast(store);

    return options;
  }
  public get device_options() {
    const devices = this.performace_select_options.device_list;

    return devices;
  }
  public get ratelist() {
    return readGetdeepTrendNode(store);
  }
  public handleCurrentChange(val) {
    this.currentPage = val;
    if (this.serch != "") {
      this.tableList_new = this.input_list.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    } else {
      this.tableList_new = this.tableList.slice(
        (this.currentPage - 1) * 10,
        this.currentPage * 10
      );
    }
  }
  public async serchChange_enter() {
    this.currentPage = 1;
    let list = this.tableList.filter((v) => {
      return v.name.toUpperCase().includes(this.serch.toUpperCase());
    });

    this.total = list.length;
    this.tableList_new = list.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
    if (this.inputValue) {
      let result = [];
      this.stackData_all.forEach((item) => {
        this.searchByName(item, this.inputValue, result);
      });
      this.close1(this.stackData_all, false);

      await result.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });
      let c = result.filter((v) => v.name.includes(this.inputValue));
      c.forEach((v, index) => {
        if (document.getElementById(v.id) != null) {
          document.getElementById(v.id).style.color = "orange";
          if (index == 0) {
            //                    const parentEl = document.getElementById(v.id).parentElement;
            // parentEl.style.overflow = 'visible'
            document.getElementById(v.id).scrollIntoView();
          }
        }
      });
    } else {
      this.close1(this.stackData_all, false);
    }
  }
  public input_list = [];
  public async serchChange() {
    this.currentPage = 1;
    this.input_list = this.tableList.filter((v) => {
      return v.name.toUpperCase().includes(this.serch.toUpperCase());
    });

    this.total = this.input_list.length;
    this.tableList_new = this.input_list.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
  }
  public itemKey = 0;
  public async checkChange(item, id, name) {
    this.stackData_all.some((v) => this.updateCheckById(v, name, item));

    // (this.$refs.table as any).toggleRowExpansion(this.stackData_all[0], true);

    await dispatchDeepPerformanceTrendNode(store, {
      project: this.localProject,
      id_test: this.dataConsumeOptions.id_test,
      node_id: id,
    });
    if (item) {
      this.series_list.push({
        name: name,
        type: "line",

        showSymbol: false,
        id: id,
        itemStyle: {
          normal: {
            lineStyle: {
              width: 1,
            },
          },
          emphasis: {
            lineStyle: {
              width: 1, // hover时的折线宽度
            },
          },
        },
        yAxisIndex: 0,
        data: this.ratelist.map((item) => (item === null ? 0 : item)),
      });
    } else {
      let target_index = this.series_list.findIndex((v) => v.name == name);
      this.series_list.splice(target_index, 1);
    }
    // this.tree_func()
    this.selectData(this.trendInex);
    this.drawAnalyseTrend();
  }
  public lastDevice = [];
  public lastScene = [];

  public lastDeviceOptions() {
    this.lastDevice = this.device_options;
  }
  public lastSceneOptions() {
    this.lastScene = this.scene_options;
  }
  public get device_options_old() {
    const devices = this.performace_select_options_old.device_list;

    return devices;
  }
  public get device_options_last() {
    const devices = this.performace_select_options_last.device_list;

    return devices;
  }
  public get cpu_by_frame_list() {
    let list = JSON.parse(JSON.stringify(readGetdeepCpuByFrame(store)));
    let list1 = [];
    list.labels.forEach((v, index) => {
      list1.push(v.map((k) => k + "_" + index));
    });

    return list1;
  }
  public get cpu_by_frame() {
    return readGetdeepCpuByFrame(store);
  }
  public get cpu_by_frame_img() {
    //   if( readGetdeepCpuByFrame(store).screen_shot?.rows!=undefined){
    //      readGetdeepCpuByFrame(store).screen_shot.rows.row=[1,1,3,5,7,9,11,13,15,17,19]
    //   readGetdeepCpuByFrame(store).screen_shot.rows.screen_shot=[
    //   { img: require("../../assets/test/6.jpg") },
    //   { img: require("../../assets/test/10.jpg") },
    //   { img: require("../../assets/test/8.jpg") },
    //   { img: require("../../assets/test/24.jpg") },
    //   { img: require("../../assets/test/9.jpg") },
    //   { img: require("../../assets/test/22.jpg") },
    //   { img: require("../../assets/test/14.jpg") },
    //   { img: require("../../assets/test/15.jpg") },
    //   { img: require("../../assets/test/16.jpg") },
    //   { img: require("../../assets/test/17.jpg") },
    // ];
    //   }

    return readGetdeepCpuByFrame(store).screen_shot;
  }
  public runMax(id_test) {
    const { href } = this.$router.resolve({
      path: "/nav/runmax/client-perf-test-report",
      query: {
        id_test: id_test,
        project: this.localProject,
      },
    });
    window.open(href, "_blank");
  }
  public get pictureArr() {
    let list = [];
    this.cpu_by_frame_img?.rows?.row.forEach((v, index) => {
      // list.push({
      //   img: this.cpu_by_frame_img.rows.screen_shot[index]?.img,
      //   time: v,
      // });
      list.push({
        img: this.cpu_by_frame_img.rows.screen_shot[index],
        time: v,
      });
    });
    return list;
  }
  public getNum(item1, item2) {
    if (item1 == "" || item2 == null || item2 == "--") {
      return "--";
    }

    if (item1 > item2) {
      return (item1 - item2).toFixed(2) + "↑";
    } else if (item1 < item2) {
      return (item2 - item1).toFixed(2) + "↓";
    }
    if (item1 === item2) {
      return "--";
    }
  }
  public addBtn() {
    this.module_list.push({
      name: "",
      value: [],
    });
  }
  public get function_list_data() {
    return readGetdeepCpuFunction(store).data;
  }
  public get function_label_list() {
    return readGetdeepCpuFunction(store).label_list;
  }
  public newResult = [];
  public get scene_options() {
    const scene_list: any[] = this.performace_select_options.scene_list;

    return scene_list;
  }
  public get scene_options_old() {
    const scene_list: any[] = this.performace_select_options_old.scene_list;

    return scene_list;
  }
  public get scene_options_last() {
    const scene_list: any[] = this.performace_select_options_last.scene_list;

    return scene_list;
  }
  public com_num_color5(item, type, i) {
    if (i.indexOf("%") != -1) {
      if (typeof item == "number") {
        if (item > this.report_settings_threshold_abs[type] * 100) {
          return "red";
        } else {
          return "#606266";
        }
      }
    } else {
      return "#606266";
    }
  }
  public com_num_color3(item, item2, type, i) {
    if (type) {
      if (typeof item == "number" && typeof item2 == "number") {
        if (i.indexOf("%") != -1) {
          if (
            Math.abs(item - item2) >
            this.report_settings_threshold[type] * 100
          ) {
            if (item > item2) {
              if (i === "FPS") {
                return "#00b050";
              } else {
                return "red";
              }
            }
            if (item < item2) {
              if (i === "FPS") {
                return "red";
              } else {
                return "#00b050";
              }
            }
          }
        } else {
          if ((this.report_settings_threshold as any).freq) {
            if (
              Math.abs(item - item2) / item2 >
              (this.report_settings_threshold as any).freq
            ) {
              if (item > item2) {
                if (i === "FPS") {
                  return "#00b050";
                } else {
                  return "red";
                }
              }
              if (item < item2) {
                if (i === "FPS") {
                  return "red";
                } else {
                  return "#00b050";
                }
              }
            }
          }
        }
      }
    }
  }
  public get subScene() {
    return readGetdeepCpuLabels(store).data;
  }
  public get subSceneOld() {
    return readGetdeepCpuLabelsOld(store).data;
  }
  public get versionsOptions() {
    return readGetdeepCpuVersions(store).data;
  }
  public get versionsOldOptions() {
    return readGetdeepCpuVersionsOld(store).data;
  }
  public get threadOptions() {
    this.cpu_function_thread_list = readGetdeepCpuThreads(store).data;

    return this.cpu_function_thread_list;
  }
  public get threadOptions1() {
    this.cpu_function_thread_list1 = readGetdeepCpuThreads(store).data;

    return this.cpu_function_thread_list1;
  }
  public getDay(day: any) {
    var today = new Date();
    var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  }
  public doHandleMonth(month: any) {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  }
  public async dataChange(item) {
    //  判断时间
    // this.threadLoading = true;
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.dataOptions.pick !== null) {
      startTimeAll = dateConversion(this.dataOptions.pick[0]);
      endTimeAll = dateConversion(this.dataOptions.pick[1]);
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.dataOptions.pick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }

    for (let v of item) {
      if (v === "date") {
        this.dataOptions.device = this.device_options[0].device_id;
        this.dataOptions.scene = this.scene_options[0].scene_id;
      }

      if (v === "scene") {
        await Promise.all([
          dispatchDeepPerformanceCpuLabels(store, {
            project: this.localProject,
            start: startTimeAll,
            end: endTimeAll,
            device_id: Number(this.dataOptions.device),
            scene_id: Number(this.dataOptions.scene),
            id_test: this.id_test,
          }),
        ]);

        this.dataOptions.subScene = this.subScene[0].lable_name;
      }
    }

    // await dispatchDeepPerformanceCpuCpuTrend(store, {
    //   project: this.localProject,
    //   start: this.getDay(-31),
    //   end: this.getDay(0),
    //   device_id: Number(this.dataOptions.device),
    //   scene_id: Number(this.dataOptions.scene),
    //   threads: this.threadTrendOptions,
    //   label: this.dataOptions.subScene,
    //   id_test: this.dataConsumeOptions.id_test,
    // }),
    //   await dispatchDeepPerformanceCpuCpuSoTrend(store, {
    //     project: this.localProject,
    //     start: this.getDay(-31),
    //     end: this.getDay(0),
    //     device_id: Number(this.dataOptions.device),
    //     scene_id: Number(this.dataOptions.scene),
    //     thread: this.trendOptions.thread,
    //     label: this.dataOptions.subScene,
    //     id_test: this.dataConsumeOptions.id_test,
    //   });
    // await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
    //   project: this.localProject,
    //   start: this.getDay(-31),
    //   end: this.getDay(0),
    //   device_id: Number(this.dataOptions.device),
    //   scene_id: Number(this.dataOptions.scene),
    //   thread: this.trendOptions.thread,
    //   label: this.dataOptions.subScene,
    //   so: this.trendOptions.so,
    //   id_test: this.dataConsumeOptions.id_test,
    // });
    // this.circleflag = false;
    // await this.drawThreadTrend();
    // await this.drawSoTrend();
    // await this.drawMoTrend();
    // this.threadLoading = false;
  }
  public async affirm() {
    this.threadLoading = true;
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.dataOptions.pick !== null) {
      startTimeAll = dateConversion(this.dataOptions.pick[0]);
      endTimeAll = dateConversion(this.dataOptions.pick[1]);
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.dataOptions.pick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }
    await dispatchDeepPerformanceCpuCpuTrend(store, {
      project: this.localProject,
      start: startTimeAll,
      end: endTimeAll,
      device_id: Number(this.dataOptions.device),
      scene_id: Number(this.dataOptions.scene),
      threads: this.threadTrendOptions,
      label: this.dataOptions.subScene,
      id_test: this.dataConsumeOptions.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    if (this.soShow == true) {
      await dispatchDeepPerformanceCpuCpuSoTrend(store, {
        project: this.localProject,
        start: startTimeAll,
        end: endTimeAll,
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),
        thread: this.trendOptions.thread,
        label: this.dataOptions.subScene,
        id_test: this.dataConsumeOptions.id_test,
      });
    }

    await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
      project: this.localProject,
      start: startTimeAll,
      end: endTimeAll,
      device_id: Number(this.dataOptions.device),
      scene_id: Number(this.dataOptions.scene),

      label: this.dataOptions.subScene,

      id_test: this.dataConsumeOptions.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    this.circleflag = false;
    await this.drawThreadTrend();
    if (this.soShow == true) {
      await this.drawSoTrend();
    }

    await this.drawMoTrend();

    this.threadLoading = false;
  }
  public affirm1() {
    this.cpuTrendLoading = true;
    let startTimeAll = "";
    let endTimeAll = "";

    if (this.trendData.pick !== null) {
      startTimeAll = dateConversion(this.trendData.pick[0]);
      endTimeAll = dateConversion(this.trendData.pick[1]);
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.trendData.pick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }
    dispatchDeepPerformanceCpuUsageTrend(store, {
      project: this.localProject,
      start: startTimeAll,
      end: endTimeAll,
      device_id: Number(this.trendData.device),
      scene_id: Number(this.trendData.scene),
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    }).then((res) => {
      this.drawCpuTrend();
      this.cpuTrendLoading = false;
    });
  }
  public async affirmBtn() {
    this.functiontableLoading = true;
    this.functionNameLoading = true;
    let date = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;
    let version = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    let old_date = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].date;
    let old_version = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].game_version;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;
    await dispatchDeepPerformanceCpuLabelsOld(store, {
      project: this.localProject,
      date: date,
      version: version,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
    });
    this.dataConsumeOptions.subScene = this.subSceneOld[0]?.lable_name;
    await dispatchDeepPerformanceCpuCpuFunctionOverview(store, {
      project: this.localProject,
      date: date,
      old_date: old_date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      old_version: old_version,
      id_test: this.id_test,
      old_test: old_test,
    });
    await dispatchDeepPerformanceCpuUsageList(store, {
      project: this.localProject,

      id_test: this.id_test,
      old_test: old_test,
      fps_rate: "",
    });
    await this.overviewHead();
    this.functiontableLoading = false;
    await dispatchDeepPerformanceCpuCpuFunction(store, {
      project: this.localProject,
      date: date,
      old_date: old_date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      old_version: old_version,
      id_test: this.id_test,
      thread: this.dataConsumeOptions.thread,
      label: this.dataConsumeOptions.subScene,
      old_test: old_test,
    });

    this.functionNameLoading = false;
  }
  public setCheckTrueById(data, id) {
    data.forEach((item) => {
      if (item.id == id) {
        item.check = true;
      }
    });
    console.log(data);
  }
  public auto_data = [
    { id: 2, label: "自动", check: false },
    { id: 0, label: "手动", check: false },
  ];
  // public type_data=[ { id: 3, label: "局内皮肤测试",check:false}, { id: 4, label: "局外皮肤测试",check:false }, { id: 9, label: "5V5真人测试",check:false } ]
  //  public get sub_data(){
  //    let list=[]
  //    if(this.type_data[2].check==true){
  //       list=[ { id: 0, label: "default",check:false}, { id: 1, label: "开profile",check:false }, { id: 2, label: "关profile",check:false } ]
  //    }else{
  //      list=[ { id: 0, label: "default",check:false}]
  //    }
  //    return list
  // }
  // public sub_data=[ { id: 0, label: "default",check:false}, { id: 1, label: "开profile",check:false }, { id: 2, label: "关profile",check:false } ]
  public async affirmBtn2() {
    this.functionStack = true;
    this.functionStack1 = true;
    this.functionNameTrend = true;

    this.startValue = 0;
    this.endValue = 100;

    (this.selectShow = true), //控制框选文字
      (this.currentPage = 1);
    this.coordRange = []; //
    this.trendInex = 0;
    this.serch = "";
    this.makLineShow = true;
    //  this.month = this.cpu_by_frame?.frame_index[0];
    // this.abs_time = this.cpu_by_frame?.abs_time[0];
    let date = this.versionsOptions.filter(
      (v) => v.chinese == this.trendDataOptions.version
    )[0].date;
    let version = this.versionsOptions.filter(
      (v) => v.chinese == this.trendDataOptions.version
    )[0].game_version;
    // let old_date = this.versionsOldOptions.filter(
    //   (v) => v.chinese == this.trendDataOptions.old_verson
    // )[0].date;
    // let old_version = this.versionsOldOptions.filter(
    //   (v) => v.chinese == this.dataConsumeOptions.old_verson
    // )[0].game_version;

    await dispatchDeepPerformanceCpuCpuByFrame(store, {
      project: this.localProject,
      date: date,
      device_id: Number(this.trendDataOptions.device),
      scene_id: Number(this.trendDataOptions.scene),
      version: version,
      id_test: this.new_id_test,
      thread: this.dataConsumeOptions.thread,
    });

    dispatchDeepPerformanceFlameGraphUrl(store, {
      project: this.localProject,
      id_test: Number(readGetdeepCpuByFrame(store).id_test),
    });
    dispatchDeepPerformancefuncList(store, {
      project: this.localProject,
      id_test: Number(readGetdeepCpuByFrame(store).id_test),
    });
    await this.labels;
    this.series();
    this.legendData();
    await this.$nextTick(() => {
      this.drawAnalyseTrend();
    });
    this.overall();
    this.getFramesInfo(this.trendInex, this.trendInex);
    this.selectData(this.trendInex);
    this.functionNameTrend = false;
    // await dispatchDeepPerformanceCpuStackCreated(store, {
    //   project: this.localProject,
    //   id_test: Number(readGetdeepCpuByFrame(store).id_test),
    //   frame:  this.cpu_by_frame.frame_index[0],
    //     depth:0,
    //     id_row:'',
    //   thread:this.lastThread,
    //    abs_time:this.cpu_by_frame.abs_time[0]
    // });
    this.testShow = false;
    await dispatchDeepPerformanceCpuStack(store, {
      project: this.localProject,
      id_test: Number(readGetdeepCpuByFrame(store).id_test),
      frame: this.month,
      thread: this.threadTrendOptions,
    });
    this.testShow = true;
    this.activeNames = [];
    this.tableList_storage = [];
    this.tree_storage = [];
    this.flame_storage = [];
    //     this.tableList = this.getTop10(this.stackData_obj).slice(1);
    //   this.tableList.forEach((v) => {
    //             let found = false;
    //             this.series_list.forEach((item) => {
    //               if (v.id == item.id) {
    //                 v.check = true;
    //                 found = true;
    //                 return false; // 跳出循环
    //               }
    //               if (!found) {
    //                 v.check = false;
    //               }
    //             });
    //           });
    //              this.stackData_all.forEach(v=>{
    //             this.updateCheckProperty(v, this.series_list);
    //           })
    //         let names = this.tableList.map(item => item.id);
    // const result = Object.entries(this.func_list).filter(([key, value]) => !names.includes(key));

    // // 将结果转换为对象
    // const filteredObj :any= Object.fromEntries(result);
    //    for(let i in  this.func_list){
    //      this.tableList.forEach(v=>{
    //        if(v.id===i){
    //          v.average_value=this.func_list[i].value
    //          v.difference=(v.time- v.average_value).toFixed(2)
    //        }

    //      })
    //    }
    //    for (let i in  filteredObj){
    //      if( filteredObj[i].name!='FrameTime'){
    // this.tableList.push({name:filteredObj[i].name,id:i,time:0,rate:0,average_value:filteredObj[i].value,difference:0-filteredObj[i].value,check:false})
    //      }

    //    }
    //     this.tableList_new = this.tableList.slice(
    //       (this.currentPage - 1) * 10,
    //       this.currentPage * 10
    //     );
    //     if (this.testShow == true) {
    //       console.log(this.$refs.table as any);
    //       // (this.$refs.table as any).toggleRowExpansion(
    //       // this. stackData[0],
    //       //   true
    //       // );
    //       // this.$nextTick(() => {
    //       // (this.$refs.table as any).toggleRowExpansion(
    //       // this. stackData[0],
    //       //   true
    //       // );
    //       //   this.expanded();
    //       // });
    //     }
    //     this.total = this.tableList.length;
    //     this.renderFlame("#chart", this.stackData_obj);
    // let c = (this.$refs.iframeDom as any).contentWindow;
    // let iframe: any = document.getElementById("bdIframe");
    // c.postMessage(
    //   {
    //     cmd: JSON.stringify(this.stackData_obj),
    //     apiUrl: 3,
    //     params: {},
    //   },
    //   "*"
    // ),
    //   window.addEventListener("message", (e) => {
    //     let data = e.data;

    //     iframe.height = Number(data.c) + 20 + "px";
    //   }),
    this.functionStack = false;
    this.functionStack1 = false;
  }
  public params = [
    { name: "Total%", value: "avg_cpu_total" },
    { name: "App%", value: "avg_cpu" },
    { name: "CPU0%", value: "cpu_usage_0" },
    { name: "CPU1%", value: "cpu_usage_1" },
    { name: "CPU2%", value: "cpu_usage_2" },
    { name: "CPU3%", value: "cpu_usage_3" },
    { name: "CPU4%", value: "cpu_usage_4" },
    { name: "CPU5%", value: "cpu_usage_5" },
    { name: "CPU6%", value: "cpu_usage_6" },
    { name: "CPU7%", value: "cpu_usage_7" },
    { name: "Freq MHz", value: "avg_cpu_freq" },
  ];
  public id_test = "";
  public functiontableLoading = false;
  public async versionChange(item, type) {
    // this.functionNameLoading = true;
    // this.functionNameTrend = true;
    if (this.num != -1) {
      if (this.changeList[this.num]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList[this.num][0]?.id) != null
          ) {
            document.getElementById(
              this.changeList[this.num][0].id
            ).style.color = "#fff";
          }
          this.num = -1;
          this.changeList = [];
          this.inputValue = "";
        });
      }
    }
    // this.month = this.cpu_by_frame?.frame_index[0];
    // this.abs_time = this.cpu_by_frame?.abs_time[0];
    let date = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;
    let version = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    let old_date = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].date;
    let old_version = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].game_version;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;

    if (type == true) {
      this.id_test = "";
    }

    for (let v of item) {
      if (v == "version") {
        await dispatchGetDeepPerformanceSelectOptionsOld(store, {
          project: this.localProject,
          date: date,
          game_version: version,
        });
        this.dataConsumeOptions.device = this.device_options_old[0].device_id;

        this.dataConsumeOptions.scene = this.scene_options_old[0].scene_id;
      }
      if (v === "scene") {
        await dispatchDeepPerformanceCpuCpuVersionsOld(store, {
          project: this.localProject,
          device_id: Number(this.dataConsumeOptions.device),
          scene_id: Number(this.dataConsumeOptions.scene),
          is_auto: this.auto_query,
          type: this.type_query,
          subtype: this.subtype_query,
        });
        if (this.versionsOldOptions.length == 1) {
          this.dataConsumeOptions.old_verson = this.versionsOldOptions[0].chinese;
        }
        if (this.versionsOldOptions.length > 1) {
          let index_num = 0;
          let index = this.versionsOldOptions.findIndex(
            (v) => v.chinese == this.dataConsumeOptions.version
          );
          if (index == this.versionsOldOptions.length - 1) {
            index_num = index - 1;
          } else {
            index_num = index + 1;
          }

          this.dataConsumeOptions.old_verson = this.versionsOldOptions[
            index_num
          ].chinese;
        }
        // this.dataConsumeOptions.old_verson =
        //   this.versionsOldOptions.length > 1
        //     ? this.versionsOldOptions[1].chinese
        //     : this.versionsOldOptions[0].chinese;
      }
      //   if (v === "idLabel") {
      //     await dispatchDeepPerformanceCpuLabelsOld(store,{
      //           project: this.localProject,
      //     date:date,
      //     version: version,
      //     device_id: Number(this.dataConsumeOptions.device),
      //     scene_id: Number(this.dataConsumeOptions.scene),
      // })
      //     this.dataConsumeOptions.subScene=this.subSceneOld[0]?.lable_name
      //   }
      if (v === "subScene") {
        this.functionNameLoading = true;
        await dispatchDeepPerformanceCpuCpuFunction(store, {
          project: this.localProject,
          date: date,
          old_date: old_date,
          device_id: Number(this.dataConsumeOptions.device),
          scene_id: Number(this.dataConsumeOptions.scene),
          version: version,
          old_version: old_version,
          id_test: this.id_test,
          thread: this.dataConsumeOptions.thread,
          label: this.dataConsumeOptions.subScene,
          old_test: old_test,
        });
        this.functionNameLoading = false;
      }
    }

    // this.dataConsumeOptions.id_test = "";

    // await dispatchDeepPerformanceCpuCpuFunction(store, {
    //   project: this.localProject,
    //   date: date,
    //   old_date: old_date,
    //   device_id: Number(this.dataConsumeOptions.device),
    //   scene_id: Number(this.dataConsumeOptions.scene),
    //   version: version,
    //   old_version: old_version,
    //   id_test: this.id_test,
    //   thread: this.dataConsumeOptions.thread,
    //      label:this.dataConsumeOptions.subScene
    // });
    // this.functionNameLoading = false;
    // await dispatchDeepPerformanceCpuCpuByFrame(store, {
    //   project: this.localProject,
    //   date: date,
    //   device_id: Number(this.dataConsumeOptions.device),
    //   scene_id: Number(this.dataConsumeOptions.scene),
    //   version: version,
    //   id_test: this.id_test,
    //   thread: this.dataConsumeOptions.thread,
    // });
    // await this.labels;
    // await this.$nextTick(() => {
    //   this.drawAnalyseTrend();
    // });
    // this.functionNameTrend = false;
    // await dispatchDeepPerformanceCpuStackCreated(store, {
    //   project: this.localProject,
    //   id_test: Number(readGetdeepCpuByFrame(store).id_test),
    //   frame:  this.cpu_by_frame.frame_index[0],
    //     depth:0,
    //     id_row:'',
    //   thread:this.lastThread,
    //    abs_time:this.cpu_by_frame.abs_time[0]
    // });
    // await dispatchDeepPerformanceCpuStack(store, {
    //   project: this.localProject,
    //   id_test: Number(readGetdeepCpuByFrame(store).id_test),
    //   frame: this.cpu_by_frame.frame_index[0],
    //   thread: this.threadTrendOptions,
    //   abs_time: this.cpu_by_frame.abs_time[0],
    // });
    // this.functionStack = false;
  }
  public async versionChange1(type) {
    this.new_id_test = "";
    if (type == true) {
      let date = this.versionsOptions.filter(
        (v) => v.chinese == this.trendDataOptions.version
      )[0].date;
      let version = this.versionsOptions.filter(
        (v) => v.chinese == this.trendDataOptions.version
      )[0].game_version;
      await dispatchGetDeepPerformanceSelectOptionsLast(store, {
        project: this.localProject,
        date: date,
        game_version: version,
      });
      this.lastDevice = this.device_options_last;
      this.lastScene = this.scene_options_last;
      this.trendDataOptions.device = this.device_options_last[0].device_id;

      this.trendDataOptions.scene = this.scene_options_last[0].scene_id;
    }
  }
  public displaylist = "";
  public maskImg = {
    img: "",
  };
  public addShow = false;
  public showMask = false;
  public closePictureBtn = false;
  public btn(a) {
    this.displaylist = a;

    this.maskImg.img = this.pictureArr[a]?.img;
    this.showMask = true;
    this.closePictureBtn = true;
  }
  public new_id_test = "";
  //   public getPictureData(){

  //   }
  // public get
  public threadName = 0;
  public soName = 0;
  public moudelName = 0;
  public getChinese(i) {
    if (i === "single_frame_time") {
      return "单帧平均耗时(ms)";
    } else {
      return i;
    }
  }
  public drawSoTrend() {
    let series = [];

    this.soTrend_data.chinese.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.soTrend_data.series[index],
        // symbolSize: 8,
      });
    });
    // if (this.circleflag === false && series.length > 0) {
    //   series[0].itemStyle = {
    //     normal: {
    //       lineStyle: {
    //         width: 100,
    //       },
    //     },
    //     emphasis: {
    //       lineStyle: {
    //         width: 1, // hover时的折线宽度
    //       },
    //     },
    //   };
    //   series[0].symbolSize = 8;
    //   series[0].symbol = "emptyCircle";
    // } else {
    //   let num = 0;
    //   this.soTrend_data.so_list.forEach((v, i) => {
    //     if (v === this.trendOptions.so) {
    //       num = i;
    //     }
    //     series.forEach((v, index) => {
    //       if (index == num) {
    //         v.itemStyle = {
    //           normal: {
    //             lineStyle: {
    //               width: 100,
    //             },
    //           },
    //           emphasis: {
    //             lineStyle: {
    //               width: 1, // hover时的折线宽度
    //             },
    //           },
    //         };
    //         v.symbol = "emptyCircle";
    //         v.symbolSize = 8;
    //       } else {
    //         v.symbol = "circle";
    //         v.symbolSize = 5;
    //       }
    //     });
    //   });
    // }

    let performance_line: any = document.getElementById("soTrend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    // contrastChart.on("click", (params) => {
    //   this.soLoading = true;
    //   // 控制台打印数据的名称
    //   let startTimeAll = "";
    //   let endTimeAll = "";
    //   if (this.dataOptions.pick !== null) {
    //     startTimeAll = dateConversion(this.dataOptions.pick[0]);
    //     endTimeAll = dateConversion(this.dataOptions.pick[1]);
    //   }

    //   startTimeAll = startTimeAll === "-" ? this.getDay(-31) : startTimeAll;
    //   endTimeAll = endTimeAll === "-" ? this.getDay(0) : endTimeAll;
    //   if (this.dataOptions.pick == null) {
    //     startTimeAll = this.getDay(-31);
    //     endTimeAll = this.getDay(0);
    //   }
    //   let num = 0;
    //   this.soTrend_data.chinese.forEach((v, i) => {
    //     if (v === params.seriesName) {
    //       num = i;
    //     }
    //   });
    //   series.forEach((v) => {
    //     if (v.name == params.seriesName) {
    //       v.itemStyle = {
    //         normal: {
    //           lineStyle: {
    //             width: 100,
    //           },
    //         },
    //         emphasis: {
    //           lineStyle: {
    //             width: 1, // hover时的折线宽度
    //           },
    //         },
    //       };
    //       v.symbol = "emptyCircle";
    //       v.symbolSize = 8;
    //     } else {
    //       v.symbol = "circle";
    //       v.symbolSize = 5;
    //     }
    //   });
    //   // console.log(data.filter(v=>v.name==params.seriesName)[0])
    //   contrastChart.setOption({
    //     series: series,
    //   });
    //   this.soName = this.soTrend_data.so_list[num];
    //   dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
    //     project: this.localProject,
    //     start: startTimeAll,
    //     end: endTimeAll,
    //     device_id: Number(this.dataOptions.device),
    //     scene_id: Number(this.dataOptions.scene),
    //     thread: this.threadName,
    //     label: this.dataOptions.subScene,
    //     so: this.soName,
    //     id_test: this.dataConsumeOptions.id_test,
    //   }).then((res) => {
    //     this.soTrendShow = true;
    //     this.$nextTick(() => {
    //       this.drawMoTrend();
    //     });
    //   });
    //   this.soLoading = false;
    // });
    // contrastChart.getZr().on("click", (params) =>  {
    //    var pointInPixel = [params.offsetX, params.offsetY];
    //   if (contrastChart.containPixel("grid", pointInPixel)) {
    //      var pointInGrid = contrastChart.convertFromPixel(
    //         { seriesIndex: 0 },
    //         pointInPixel
    //       );
    //       //X轴序号
    //       var xIndex = pointInGrid[0];

    //       //获取当前图表的option
    //       var op = contrastChart.getOption();
    //       console.log(op.series[0].name)
    //       //获得图表中我们想要的数据
    //       var month = op.xAxis[0].data[xIndex];
    //       var value = op.series[0].data[xIndex];
    //       console.log(month,value)
    //   }
    // })
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.soTrend_data.date_list,
      },

      series: series,
    });
  }
  public drawMoTrend() {
    let series = [];

    (this.moTreend_data as any).chinese.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: (this.moTreend_data as any).series[index],
      });
    });
    let performance_line: any = document.getElementById("moudelTrand");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);

    // contrastChart.getZr().on("click", (params) =>  {
    //    var pointInPixel = [params.offsetX, params.offsetY];
    //   if (contrastChart.containPixel("grid", pointInPixel)) {
    //      var pointInGrid = contrastChart.convertFromPixel(
    //         { seriesIndex: 0 },
    //         pointInPixel
    //       );
    //       //X轴序号
    //       var xIndex = pointInGrid[0];

    //       //获取当前图表的option
    //       var op = contrastChart.getOption();
    //       console.log(op.series[0].name)
    //       //获得图表中我们想要的数据
    //       var month = op.xAxis[0].data[xIndex];
    //       var value = op.series[0].data[xIndex];
    //       console.log(month,value)
    //   }
    // })
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.moTreend_data.date_list,
      },

      series: series,
    });
    // contrastChart.on("click", (params) => {
    //     series.forEach(v=>{
    //     if(v.name==params.seriesName){
    //       v.itemStyle=  {
    //       normal: {
    //         lineStyle: {
    //           width: 100,
    //         },
    //       },
    //       emphasis: {
    //         lineStyle: {
    //           width: 1, // hover时的折线宽度
    //         },
    //       },
    //     }
    //     v.symbol='emptyCircle'
    //     v.symbolSize=8
    //     }else{
    //       v.symbol='circle'
    //         v.symbolSize=5
    //     }
    //   })
    //   // console.log(data.filter(v=>v.name==params.seriesName)[0])
    //   contrastChart.setOption({
    //     series:series

    //   })
    // })
  }

  public async open() {
    let reportseTting = this.custom_json;
    await actionDeepPerformanceCpuPutCheck(store, {
      project: this.localProject,
      settings: reportseTting,
    });
    await this.$nextTick(() => {
      let b = document.getElementById("sss");

      b.innerHTML = this.custom_json;

      let data = readGetdeepCpuCheck(store).data;

      let n = "";

      let c = "";
      readGetdeepCpuCheck(store).data.forEach((v) => {
        b.innerHTML = this.custom_json.replace(
          v,
          `<span style="background:red">${v}</span>`
        );
        this.custom_json = b.innerHTML;
      });
    });
  }
  // public onSubmit(){
  //   console.log(this.$refs.popover);
  //   (this.$refs.popover as any).visibility=false;
  // }
  public inputValue = "";
  public changeList = [];
  public tableAddShow = false;
  public drawCpuTrend() {
    let series = [];
    let xData = [];
    let yaxis: any = [] || {};
    this.cpuDataTrend.chinese.forEach((v, index) => {
      series.push({
        name: v,
        type: "line",
        data: this.cpuDataTrend.series[index],
        smooth: true, // 平滑曲线
        symbol: "circle", //拐点设置为实心,

        itemStyle: {
          normal: {
            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
            },
          },
        },

        yAxisIndex: v === "Freq MHz" ? 1 : 0,
        // yAxisIndex: v === "avg_cpu_freq" ? 1 : 0,
      });

      xData = this.cpuDataTrend.date_list;
      yaxis = [
        {
          name: "",
          type: "value",
        },
        {
          type: "value",
          splitLine: {
            show: false,
          },
        },
      ];
    });
    let performance_line: any = document.getElementById("cpu");
    echarts.dispose(performance_line);
    let PerformanceLineChart = echarts.init(performance_line);
    let option;
    option = {
      title: {
        left: "center",
        textStyle: {
          fontSize: 16,
          fontWeight: "normal",
        },
      },
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "20%",
        right: "4%",
        containLabel: true,
      },

      animation: false,
      xAxis: {
        type: "category",
        data: xData,
      },
      yAxis: yaxis,
      series: series,
    };
    PerformanceLineChart.setOption(option);
  }
  public get cpuDataTrend() {
    return readGetdeepCpuUsageTrend(store).data;
  }
  public searchByName(obj, query, result, path = []) {
    if (obj.name && obj.name.includes(query)) {
      const reversedPath = [...path, obj].reverse();
      reversedPath.forEach((item) => {
        const newItem = { ...item };
        delete newItem.children;
        result.push(newItem);
      });
    }

    if (Array.isArray(obj.children)) {
      obj.children.forEach((child) => {
        this.searchByName(child, query, result, [...path, obj]);
      });
    }
  }

  public async submit() {
    // (this.$refs.table as any).toggleRowExpansion(this.stackData[0], true);
    this.num += 1;
    if (this.inputValue) {
      let result = [];
      this.stackData_all.forEach((item) => {
        this.searchByName(item, this.inputValue, result);
      });
      this.close1(this.stackData_all, false);

      await result.forEach((v) => {
        (this.$refs.table as any).toggleRowExpansion(v, true);
      });
      let c = result.filter((v) => v.name.includes(this.inputValue));
      c.forEach((v, index) => {
        if (document.getElementById(v.id) != null) {
          document.getElementById(v.id).style.color = "orange";
          if (index == 0) {
            //                    const parentEl = document.getElementById(v.id).parentElement;
            // parentEl.style.overflow = 'visible'
            document.getElementById(v.id).scrollIntoView();
          }
        }
      });
    } else {
      this.close1(this.stackData_all, false);
    }
  }
  public trendInex = 0;

  public downloadFile(url) {
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // 可以设置下载文件的名称，留空则使用原文件名
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  public formTask = false;
  public async drawAnalyseTrend() {
    let performance_line: any = document.getElementById("analyse");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    let series = [];
    let xAxis = [];
    for (let i = 0; i < this.cpu_by_frame?.frame_index.length; i++) {
      xAxis.push(i);
    }

    if (this.makLineShow) {
      this.series_list[0].markLine = {
        symbol: ["circle", "arrow"],
        data: [
          {
            silent: false,
            xAxis: this.trendInex,
            label: {
              position: "end",
              formatter: String(this.trendInex * 10),
              show: this.makLineShow,
              color: "ED5664",
            },
            lineStyle: {
              type: "solid",
              color: "#ED5664",
              width: "1",
            },
          },
        ],
      };
    } else {
      this.series_list[0].markLine = {
        data: [],
        label: {
          show: this.makLineShow,
        },
      };
    }

    contrastChart.on("datazoom", (params: any) => {
      let xAxis = (contrastChart as any).getModel().option; // 获取x轴数据 我这个是时间
      let series = (contrastChart as any).getModel().option.series[0]; // 获取数据
      let start_rate = params.start;
      let end_rate = params.end;
      this.startValue = start_rate;
      this.endValue = end_rate;
      // console.log(series); // 这个是获取的数据
      //           console.log(series.data);
      //            console.log(xAxis.rangeStart);//滑动条左端对应在xAxis.data的索引
      //           console.log(xAxis.rangeEnd);//滑动条右端对应在xAxis.data的索引
      // let timeIndexStart =
      //   this.cpu_by_frame.frame_index.length * (params.start / 100);
      // let timeIndexEnd =
      //   this.cpu_by_frame.frame_index.length * (params.end / 100);
      let start = (contrastChart as any).getModel().option.dataZoom[0]
        .startValue;
      let end = (contrastChart as any).getModel().option.dataZoom[0].endValue;
      let arr = this.cpu_by_frame.frame_index.filter((v, i) => {
        if (start === this.cpu_by_frame.frame_index.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      let newLabelName = this.cpu_by_frame_list.flat().filter((v, i) => {
        if (start === this.cpu_by_frame.frame_index.length) {
          return i >= start - 1 && i < end;
        } else {
          return i >= start && i <= end;
        }
      });
      var newArr = [],
        tempArr = [];
      for (var i = 0, j = newLabelName.length; i < j; i++) {
        if (newLabelName[i] == newLabelName[i + 1]) {
          tempArr.push(newLabelName[i]);
        } else {
          tempArr.push(newLabelName[i]);
          newArr.push(tempArr.slice(0));
          tempArr.length = 0;
        }
      }

      let c = newArr.flat();
      let n = Array.from(new Set(c));
      let nameArr = [];
      let name1Arr = [];
      this.labels.forEach((v) => {
        n.forEach((j) => {
          if (v.label === j) {
            nameArr.push(v);
          }
        });
      });

      newArr.forEach((v) => {
        name1Arr.push({
          label: v[0],
          width: (v.length / arr.length) * 100 + "%",
        });
      });

      nameArr.forEach((v) => {
        name1Arr.forEach((j) => {
          if (v.label == j.label) {
            v.width = j.width;
          }
        });
      });
      this.list = nameArr;
    });
    // contrastChart.dispatchAction({
    //   type: "showTip",
    //   seriesIndex: 5,
    //   dataIndex: 10,
    //   position: () => {
    //     return "top";
    //   }, // top
    // });
    contrastChart.on("brushEnd", (params: any) => {
      let list = [];
      this.inputValue = "";
      var op = contrastChart.getOption();
      if (params.areas.length > 0) {
        this.functionStack = true;
        this.functionStack1 = true;
        let start = params.areas[0]?.coordRange[0];
        let end = params.areas[0]?.coordRange[1];
        this.coordRange = [start, end];
        this.selectShow = true;
        for (
          let i = params.areas[0].coordRange[0];
          i <= params.areas[0].coordRange[1];
          i++
        ) {
          list.push(i);
        }

        this.getFramesInfo(
          params.areas[0].coordRange[0],
          params.areas[0].coordRange[1]
        );
        this.makLineShow = false;
        this.series_list[0].markLine = {
          data: [],
          label: {
            show: this.makLineShow,
          },
        };

        this.selectData();
        this.legend_data = op.legend[0].selected;
        this.drawAnalyseTrend();
        this.testShow = false;
        dispatchDeepPerformanceCpuStackMerge(store, {
          project: this.localProject,
          id_test: Number(readGetdeepCpuByFrame(store).id_test),
          frames: list,
          threads: this.threadTrendOptions,
        }).then((res) => {
          this.testShow = true;
          this.storage();
          //           this.tableList = this.getTop10(this.stackData_obj).slice(1);
          //           this.currentPage = 1;
          //              let names = this.tableList.map(item => item.id);
          // const result = Object.entries(this.func_list).filter(([key, value]) => !names.includes(key));

          // // 将结果转换为对象
          // const filteredObj :any= Object.fromEntries(result);
          //    for(let i in  this.func_list){
          //      this.tableList.forEach(v=>{
          //        if(v.id===i){
          //          v.average_value=this.func_list[i].value
          //          v.difference=(v.time- v.average_value).toFixed(2)
          //        }

          //      })
          //    }
          //    for (let i in  filteredObj){
          //      if( filteredObj[i].name!='FrameTime'){
          // this.tableList.push({name:filteredObj[i].name,id:i,time:0,rate:0,average_value:filteredObj[i].value,difference:0-filteredObj[i].value,check:false})
          //      }

          //    }
          //           this.tableList.forEach((v) => {
          //             let found = false;
          //             this.series_list.forEach((item) => {
          //               if (v.id == item.id) {
          //                 v.check = true;
          //                 found = true;
          //                 return false; // 跳出循环
          //               }
          //               if (!found) {
          //                 v.check = false;
          //               }
          //             });
          //           });
          //           this.stackData_all.forEach(v=>{
          //             this.updateCheckProperty(v, this.series_list);
          //           })

          this.close1(this.stackData_all, false);
          // (this.$refs.table as any).toggleRowExpansion(
          //   this.stackData_all[0],
          //   true
          // );
          // this.tableList_new = this.tableList.slice(
          //   (this.currentPage - 1) * 10,
          //   this.currentPage * 10
          // );
          // if (this.testShow == true) {
          //   console.log(this.$refs.table as any);
          //   // (this.$refs.table as any).toggleRowExpansion(
          //   // this. stackData[0],
          //   //   true
          //   // );
          //   // this.$nextTick(() => {
          //   // (this.$refs.table as any).toggleRowExpansion(
          //   // this. stackData[0],
          //   //   true
          //   // );
          //   //   this.expanded();
          //   // });
          // }
          this.total = this.tableList.length;
          this.serch = "";

          // this.renderFlame("#chart", this.stackData_obj),
          this.functionStack = false;
          this.functionStack1 = false;
        });
      }

      // contrastChart.setOption({
      //   title: {
      //     backgroundColor: "#333",
      //     text: "SELECTED DATA INDICES: \n",
      //     bottom: 200,
      //     right: "0%",
      //     width: 100,
      //     textStyle: {
      //       fontSize: 12,
      //       color: "#fff",
      //     },
      //   },
      // });
    });

    contrastChart.getZr().on("click", (params) => {
      var pointInPixel = [params.offsetX, params.offsetY];
      this.coordRange = [];

      this.inputValue = "";
      this.selectShow = true;
      if (contrastChart.containPixel("grid", pointInPixel)) {
        /*此处添加具体执行代码*/
        this.functionStack = true;
        this.functionStack1 = true;
        var pointInGrid = contrastChart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];
        var rangeY = (contrastChart as any).getModel().getComponent("yAxis")
          .axis.scale._extent;

        //获取当前图表的option
        var op = contrastChart.getOption();

        //获得图表中我们想要的数据

        var month = op.xAxis[0].data[xIndex];
        this.trendInex = month;

        this.selectData(this.trendInex);
        this.overall();
        this.getFramesInfo(month, month);
        this.makLineShow = true;
        var value = op.series[0].data[xIndex];

        if (this.pictureArr.length != 0) {
          let boxWidth = document.getElementById(
            this.pictureArr[0].time + this.pictureArr[0].img
          ).offsetWidth;
          let ofwidth = document.getElementById("cs").offsetLeft + boxWidth;

          this.pictureArr.forEach(function (v) {
            //
            v.ofwidth = ofwidth -= boxWidth + 10;
            //
            //
          });

          let x = month;
          let pictureObj = this.pictureArr.filter((v, index) => {
            return v.time === this.cpu_by_frame?.abs_time[xIndex];
          });
          if (pictureObj[0]) {
            let file1 = "";
            file1 = pictureObj[0].ofwidth + "px";
            document.getElementById(
              "scro"
            ).style.transform = `translateX(${file1})`;
            (document.getElementById(pictureObj[0].time + pictureObj[0].img)
              .firstChild as any).style.outline = "6px solid #4271fb";
            var siblings = this.sibling(
              document.getElementById(pictureObj[0].time + pictureObj[0].img)
            );
            siblings.forEach(function (v) {
              //
              v.firstChild.style.outline = 0;
            });
          }
        }
        if (this.num != -1) {
          if (this.changeList[this.num]?.length != 0) {
            this.$nextTick(() => {
              if (
                document.getElementById(this.changeList[this.num][0]?.id) !=
                null
              ) {
                document.getElementById(
                  this.changeList[this.num][0].id
                ).style.color = "#fff";
              }
              this.num = -1;
              this.changeList = [];
              this.inputValue = "";
            });
          }
        }
        this.month = this.cpu_by_frame?.frame_index[xIndex];

        this.series_list[0].markLine = {
          symbol: ["circle", "arrow"],
          data: [
            {
              silent: false,
              xAxis: month,
              label: {
                position: "end",
                formatter: month * 10,
                show: this.makLineShow,
                color: "ED5664",
              },
              lineStyle: {
                type: "solid",
                color: "#ED5664",
                width: "1",
              },
            },
          ],
        };

        this.legend_data = op.legend[0].selected;

        contrastChart.setOption({
          series: this.series_list,
        });

        this.drawAnalyseTrend();

        // let c = (this.$refs.iframeDom as any).contentWindow;
        // let iframe: any = document.getElementById("bdIframe");
        this.testShow = false;
        dispatchDeepPerformanceCpuStack(store, {
          project: this.localProject,
          id_test: Number(readGetdeepCpuByFrame(store).id_test),
          frame: this.month,
          thread: this.threadTrendOptions,
        }).then((res) => {
          this.testShow = true;

          this.storage();
          this.close1(this.stackData_all, false);

          this.currentPage = 1;

          this.total = this.tableList.length;
          this.serch = "";

          this.renderFlame("#chart", this.stackData_obj);

          this.functionStack = false;
          this.functionStack1 = false;
        });
        //
        //
      }
    });
    //   window.addEventListener("resize", () => {
    //   contrastChart.resize();
    // });

    contrastChart.setOption({
      title: {
        text: "",
        textStyle: {
          fontSize: 16,
          fontWeight: 700,
          color: "#333",
        },
      },

      yAxis: {
        type: "value",
      },
      series: this.series_list,
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: xAxis,
        axisLabel: {
          formatter: function (value, index) {
            return value * 10;
          },
        },
      },

      dataZoom: [
        //给x轴设置滚动条
        {
          start: this.startValue,
          end: this.endValue,
          type: "slider",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          left: 50, //左边的距离
          right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#ddd", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#cacaca",
            borderWidth: "1",
            shadowBlur: 2,
            background: "#ddd",
            shadowColor: "#ddd",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#1eb5e5",
            },
            {
              offset: 1,
              color: "#5ccbb1",
            },
          ]),
          backgroundColor: "#ddd", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          showDetail: true, //即拖拽时候是否显示详细数值信息 默认true
          handleIcon:
            "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          // zoomLock: false,
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      toolbox: {
        feature: {
          saveAsImage: {},
        },
        top: 20,
      },
      brush: {
        toolbox: ["lineX"],
        // brushType: "lineX",
        transformable: false,
        xAxisIndex: 0,
        // brushMode: "multiple",
        // throttleType: "debounce", //开启选中延迟后调用回调延迟
        // throttleDelay: 1000, //选中延迟后调用回调延迟时间
      },

      tooltip: {
        trigger: "axis",
        confine: true,
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "line", // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: (params) => {
          {
            //  只粘贴formatter了

            let relVal =
              Number(params[0].axisValueLabel) * this.frame_merge_size +
              "-" +
              (Number(params[0].axisValueLabel) + 1) * this.frame_merge_size;
            for (let i = 0; i < params.length; i++) {
              relVal +=
                "<div  style='display:flex;align-items:center;' ><div style='width:120px'>" +
                params[i].marker +
                params[i].seriesName +
                '</div><div style="font-weight:bold">' +
                (params[i].value == undefined ? "-" : params[i].value) + //   不同点
                "</div></div>";
            }

            return relVal;
          }
        },
        extraCssText: "white-space: normal; word-break: break-all;",

        //  formatter: function (params) {
        //   if (params instanceof Array) {
        //     let str = '';
        //     str += `${params[0].axisValue}<br/>`;
        //     params.forEach((m, index) => {

        //       str +=  `<span class="chart-tooltip-color" style="display: inline-block; margin-right: 10px; background-color: ${m.color}; width: 10px; height: 10px; border-radius:100%; margin-right: 5px"></span>`;
        //       str += `${m.seriesName}：${m.data==null?'--':m.data}`;
        //       str += `${index % 4 === 0 ? '<br/>' : ''}`; //一排放几个可根据实际情况改变
        //     });
        //     return str;
        //   }
        // },
      },
      legend: {
        type: "scroll",
        y: "bottom",

        selected: this.legend_data,
        //     formatter: function(name) {
        //   // 根据需要返回不同的文本内容
        //   return name.split['_'][0]
        // }
      },
      grid: {
        left: "8%",
        right: "4%",
        bottom: "25%",
        top: "20%",
        // containLabel: true,
      },
      animation: false,
      itemStyle: {
        normal: {
          color: "#3ba272",
          lineStyle: {
            width: 1, // 正常时的折线宽度
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
      itemStyle2: {
        normal: {
          lineStyle: {
            width: 1,
          },
        },
        emphasis: {
          lineStyle: {
            width: 1, // hover时的折线宽度
          },
        },
      },
    });
    contrastChart.dispatchAction({
      type: "brush",
      areas: [
        {
          brushType: "lineX",
          coordRange: this.coordRange,
          xAxisIndex: 0,
        },
      ],
    });
    contrastChart.dispatchAction({
      // 刷选模式的开关。使用此 action 可将当前鼠标变为可刷选状态。 事实上，点击 toolbox 中的 brush 按钮时，就是通过这个 action，将当前普通鼠标变为刷选器的。
      type: "takeGlobalCursor",
      // 如果想变为“可刷选状态”，必须设置。不设置则会关闭“可刷选状态”。
      key: "brush",
      brushOption: {
        // 参见 brush 组件的 brushType。如果设置为 false 则关闭“可刷选状态”。
        brushType: "lineX",
        // 参见 brush 组件的 brushMode。如果不设置，则取 brush 组件的 brushMode 设置。
        brushMode: "single",
      },
    });
    var rangeY = (contrastChart as any).getModel().getComponent("yAxis").axis
      .scale._extent;
  }
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  public threadTrendOptions = [];
  public soTrendOptions = [];
  public moduleTrendOptions = [];
  public los(data) {
    return data;
  }
  public get flame_url() {
    return readGetdeepFlameUrl(store);
  }
  public handleRowClick(row, column, event) {
    if (column.label === "func_name") {
      // 判断点击的是否是name列
      (this.$refs.table as any).toggleRowExpansion(row); // 手动触发行的展开/收起
    }
  }
  public async lastChange() {
    this.functionStack = true;
    this.functionStack1 = true;
    if (this.num != -1) {
      if (this.changeList[this.num]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList[this.num][0]?.id) != null
          ) {
            document.getElementById(
              this.changeList[this.num][0].id
            ).style.color = "#fff";
          }
          this.num = -1;
          this.changeList = [];
          this.inputValue = "";
        });
      }
    }
    // this.month = this.cpu_by_frame?.frame_index[0];
    // this.abs_time = this.cpu_by_frame?.abs_time[0];
    //    await dispatchDeepPerformanceCpuStackCreated(store, {
    //     project: this.localProject,
    //     id_test: Number(readGetdeepCpuByFrame(store).id_test),
    //     frame:  this.cpu_by_frame.frame_index[0],
    //       depth:0,
    //       id_row:'',
    //     thread:this.lastThread,
    //  abs_time:this.cpu_by_frame.abs_time[0]
    //   });
    this.testShow = false;
    await dispatchDeepPerformanceCpuStack(store, {
      project: this.localProject,
      id_test: Number(readGetdeepCpuByFrame(store).id_test),
      frame: this.month,

      thread: this.threadTrendOptions,
    });
    this.testShow = true;
    // let c = (this.$refs.iframeDom as any).contentWindow;
    // let iframe: any = document.getElementById("bdIframe");
    // c.postMessage(
    //   {
    //     cmd: JSON.stringify(this.stackData_obj),
    //     apiUrl: 3,
    //     params: {},
    //   },
    //   "*"
    // ),
    //   window.addEventListener("message", (e) => {
    //     let data = e.data;
    //     console.log(data);
    //     iframe.height = Number(data.c) + 20 + "px";
    //   }),
    if (this.testShow == true) {
      console.log(this.$refs.table as any);
      // (this.$refs.table as any).toggleRowExpansion(
      // this. stackData[0],
      //   true
      // );
      // this.$nextTick(() => {
      // (this.$refs.table as any).toggleRowExpansion(
      // this. stackData[0],
      //   true
      // );
      //   this.expanded();
      // });
    }
    this.renderFlame("#chart", this.stackData_obj);
    this.functionStack = false;
    this.functionStack1 = false;
  }
  public threadchange = true;
  public sochange = true;
  public lastThread = "";
  public get details_list() {
    let list: any = [];
    list = [
      { label: "func_name", prop: "name" },
      { label: "Time(ms)", prop: "value" },
      { label: "Time(%)", prop: "rate" },
    ];
    return list;
  }

  public async drawThreadTrend() {
    let data = [];
    this.thrend_data.chinese.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.thrend_data.series[index],
      });
    });

    let performance_line: any = document.getElementById("threadTrand");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);

    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "ms",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.thrend_data.date_list,
      },

      series: data,
    });
    // contrastChart.dispatchAction({
    //   type: "showTip",
    //   seriesIndex: 0,
    //   dataIndex: 0,
    // });
    // contrastChart.on("click", (params) => {
    //   this.soLoading = true;
    //   // 控制台打印数据的名称
    //   let startTimeAll = "";
    //   let endTimeAll = "";
    //   if (this.dataOptions.pick !== null) {
    //     startTimeAll = dateConversion(this.dataOptions.pick[0]);
    //     endTimeAll = dateConversion(this.dataOptions.pick[1]);
    //   }

    //   startTimeAll = startTimeAll === "-" ? this.getDay(-31) : startTimeAll;
    //   endTimeAll = endTimeAll === "-" ? this.getDay(0) : endTimeAll;
    //   if (this.dataOptions.pick == null) {
    //     startTimeAll = this.getDay(-31);
    //     endTimeAll = this.getDay(0);
    //   }
    //   let num = 0;
    //   this.thrend_data.chinese.forEach((v, i) => {
    //     if (v === params.seriesName) {
    //       num = i;
    //     }
    //   });
    //   console.log(params.seriesName);
    //   data.forEach((v) => {
    //     if (v.name == params.seriesName) {
    //       v.itemStyle = {
    //         normal: {
    //           lineStyle: {
    //             width: 100,
    //           },
    //         },
    //         emphasis: {
    //           lineStyle: {
    //             width: 1, // hover时的折线宽度
    //           },
    //         },
    //       };
    //       v.symbol = "emptyCircle";
    //       v.symbolSize = 8;
    //     } else {
    //       v.symbol = "circle";
    //       v.symbolSize = 5;
    //     }
    //   });
    //   // console.log(data.filter(v=>v.name==params.seriesName)[0])
    //   contrastChart.setOption({
    //     series: data,
    //   });
    //   console.log(num);
    //   this.threadName = this.thrend_data.thread_list[num];
    //   dispatchDeepPerformanceCpuCpuSoTrend(store, {
    //     project: this.localProject,
    //     start: startTimeAll,
    //     end: endTimeAll,
    //     device_id: Number(this.dataOptions.device),
    //     scene_id: Number(this.dataOptions.scene),
    //     thread: this.threadName,
    //     label: this.dataOptions.subScene,
    //     id_test: this.$route.query.id_test,
    //   })
    //     .then((res) => {
    //       this.soTrendShow = true;
    //       this.$nextTick(() => {
    //         this.drawSoTrend();
    //       });
    //     })
    //     .then((res) => {
    //       dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
    //         project: this.localProject,
    //         start: startTimeAll,
    //         end: endTimeAll,
    //         device_id: Number(this.dataOptions.device),
    //         scene_id: Number(this.dataOptions.scene),
    //         thread: this.threadName,
    //         label: this.dataOptions.subScene,
    //         so:
    //           this.soTrend_data.so_list.length === 0
    //             ? ""
    //             : this.soTrend_data.so_list[0],
    //         id_test: this.$route.query.id_test,
    //       }).then((res) => {
    //         this.drawMoTrend();
    //       });
    //     });
    //   this.soLoading = false;
    // });
    // window.addEventListener("resize", () => {
    //   contrastChart.resize();
    // });
  }
  public get thrend_data() {
    return readGetdeepCpuTrend(store).data;
  }
  public get soTrend_data() {
    return readGetdeepCpuSoTrend(store).data;
  }
  public get moTreend_data() {
    return readGetdeepCpuModuleTrend(store).data;
  }
  // public open(){
  //    this.custom_json="<span style='color:#ff0'>20</span>"
  // }
  public sibling(elm) {
    var a = [];
    var p = elm.parentNode.children;
    for (var i = 0, pl = p.length; i < pl; i++) {
      if (p[i] !== elm) a.push(p[i]);
    }
    return a;
  }
  public historyShow = false;
  public threadShow = true;
  public async closeBtn() {
    this.threadLoading = true;
    this.functionNameLoading = true;
    this.functiontableLoading = true;
    this.functionNameTrend = true;
    this.functionStack = true;
    this.functionStack1 = true;
    this.moduleLoading = true;
    this.soTrendLoading = true;
    if (this.custom_json) {
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].id_test;
      // let json= this.custom_json.replace(/\n/g,"").replace(/\r/g,"").replace(/\s|\xA0/g,"");
      // var jsonObj= eval('(' + json + ')');
      //  let reportseTting=this.custom_json.replace(/\r\n/g,'').replace(/\n/g,'').replace(/\s+/g,'')
      //  console.log(222222222)
      //  console.log(reportseTting)
      let reportseTting = document
        .getElementById("sss")
        .innerText.replace(/\r\n/g, "")
        .replace(/\n/g, "")
        .replace(/\s+/g, "");
      await actionDeepPerformanceCpuPutCheck(store, {
        project: this.localProject,
        settings: reportseTting,
      });

      if (readGetdeepCpuCheck(store).code == 1) {
        alert("JSON数据格式错误");
        return;
      } else {
        let b = (this as any).$message({
          //Message 消息提示
          message: "模块函数耗时正在重新生成",
          showClose: true,
          duration: 0,
        });
        await dispatchDeepPerformanceCpuPutDetail(store, {
          project: this.localProject,
          id_test: this.dataConsumeOptions.id_test,
          settings: reportseTting,
          old_test: old_test,
          label: this.dataConsumeOptions.subScene,
        });
        b.close();
        ElMessage.success({
          message: "配置成功",
          showClose: true,
          type: "success",
        });
      }
    }
    if (this.num != -1) {
      if (this.changeList[this.num]?.length != 0) {
        this.$nextTick(() => {
          if (
            document.getElementById(this.changeList[this.num][0]?.id) != null
          ) {
            document.getElementById(
              this.changeList[this.num][0].id
            ).style.color = "#fff";
          }
          this.num = -1;
          this.changeList = [];
          this.inputValue = "";
        });
      }
    }
    // this.month = this.cpu_by_frame?.frame_index[0];
    // this.abs_time = this.cpu_by_frame?.abs_time[0];
    this.trendInex = 0;
    let date = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;
    let date1 = this.versionsOptions.filter(
      (v) => v.chinese == this.trendDataOptions.version
    )[0].date;

    let version = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    let old_date = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].date;
    let old_version = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].game_version;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;

    await dispatchDeepPerformanceCpuDetail(store, {
      project: this.localProject,
      id_test: this.$route.query.id_test
        ? this.$route.query.id_test
        : this.detail_test.filter((v: any) => v.status === 5)[0].id_test,
    });
    this.dialogFormVisible1 = false;

    if (this.detail) {
      let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);

      // 趋势图列表默认
      this.report_settings = report_settings.show;
      this.threadShow = report_settings.module.is_show_all === 1 ? false : true;
      this.report_settings_threshold = report_settings.threshold.change;
      this.report_settings_threshold_abs = report_settings.threshold.abs;
      this.soShow = report_settings.show_so === 0 ? false : true;
      if (JSON.stringify(report_settings) === "{}") {
        await dispatchDeepPerformanceCpuCpuThreads(store, {
          project: this.localProject,

          id_test: this.dataConsumeOptions.id_test,
        });

        (this.trendOptions.thread = ""), (this.dataConsumeOptions.thread = "");
        this.trendOptions.so = "";
        // 如果无数据的逻辑 此代码与运行无关 以防备用
      } else {
        this.custom_json = readGetdeepCpuDetail(store).settings;

        // this.report_settings = { top: 5 };
        this.threadOldOptions = [];
        this.threadTrendOptions = [];
        this.soTrendOptions = [];
        if (
          Object.keys(this.report_settings).length === 1 &&
          Object.keys(this.report_settings)[0] == "top"
        ) {
          this.threadchange = true;
          await dispatchDeepPerformanceCpuCpuThreads(store, {
            project: this.localProject,

            id_test: this.dataConsumeOptions.id_test,
          });
          let reportLength = 0;
          reportLength =
            this.report_settings.top < this.threadOptions.length
              ? this.report_settings.top
              : this.threadOptions.length;

          for (let i = 0; i < reportLength; i++) {
            this.threadOldOptions.push(this.threadOptions[i]);
            this.threadTrendOptions.push(this.threadOptions[i]);
          }

          this.trendOptions.thread = this.threadTrendOptions[0];
          this.trendOptions.thread1 = this.threadTrendOptions[0];
          this.lastThread = this.threadOldOptions[0];
          this.dataConsumeOptions.thread = this.threadOldOptions[0];
          await dispatchDeepPerformanceCpuFunctionCos(store, {
            project: this.localProject,
            thread: this.trendOptions.thread,
            id_test: this.dataConsumeOptions.id_test,
          });

          for (
            let i = 0;
            i <
            (this.cpu_function_cos.length >= 5
              ? 5
              : this.cpu_function_cos.length);
            i++
          ) {
            this.soTrendOptions.push(this.cpu_function_cos[i]);
          }
          this.trendOptions.so = this.soTrendOptions[0];
        }
        if (Object.keys(this.report_settings).length > 1) {
          this.threadchange = false;
          this.threadTrendOptions = Object.keys(this.report_settings);
          this.threadOldOptions = Object.keys(this.report_settings);
          if (this.threadTrendOptions.indexOf("top") != -1) {
            this.threadTrendOptions.splice(
              this.threadTrendOptions.indexOf("top"),
              1
            );
            this.threadOldOptions.splice(
              this.threadOldOptions.indexOf("top"),
              1
            );
          }
          this.trendOptions.thread = this.threadTrendOptions[0];
          this.trendOptions.thread1 = this.threadTrendOptions[0];
          this.lastThread = this.threadOldOptions[0];
          this.dataConsumeOptions.thread = this.threadOldOptions[0];
          if (
            Object.keys(this.report_settings[this.trendOptions.thread])
              .length == 1 &&
            Object.keys(this.report_settings[this.trendOptions.thread])[0] ===
              "top"
          ) {
            this.sochange = true;
            await dispatchDeepPerformanceCpuFunctionCos(store, {
              project: this.localProject,
              thread: this.trendOptions.thread,
              id_test: this.dataConsumeOptions.id_test,
            });
            let reportLength = 0;
            reportLength =
              this.report_settings[this.trendOptions.thread].top <
              this.cpu_function_cos.length
                ? this.report_settings[this.trendOptions.thread].top
                : this.cpu_function_cos.length;
            for (let i = 0; i < reportLength; i++) {
              this.soTrendOptions.push(this.cpu_function_cos[i]);
            }
            this.trendOptions.so = this.soTrendOptions[0];
          }
          if (
            Object.keys(this.report_settings[this.trendOptions.thread]).length >
            1
          ) {
            this.sochange = false;
            this.soTrendOptions = Object.keys(
              this.report_settings[this.trendOptions.thread]
            );
            if (this.soTrendOptions.indexOf("top") != -1) {
              this.soTrendOptions.splice(this.soTrendOptions.indexOf("top"), 1);
              // this.threadOldOptions.splice(this.threadOldOptions.indexOf('top'),1)
            }
            this.trendOptions.so =
              this.soTrendOptions.length > 0 ? this.soTrendOptions[0] : "";
          }
        }
      }
      await dispatchDeepPerformanceCpuCpuTrend(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),
        threads: this.threadTrendOptions,
        label: this.dataOptions.subScene,
        id_test: this.dataConsumeOptions.id_test,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      });
      if (this.soShow == true) {
        await dispatchDeepPerformanceCpuCpuSoTrend(store, {
          project: this.localProject,
          start: "",
          end: "",
          device_id: Number(this.dataOptions.device),
          scene_id: Number(this.dataOptions.scene),
          thread: this.trendOptions.thread,
          label: this.dataOptions.subScene,
          id_test: this.dataConsumeOptions.id_test,
        });
      }

      await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),

        label: this.dataOptions.subScene,

        id_test: this.dataConsumeOptions.id_test,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      });
    }
    await this.drawThreadTrend();
    if (this.soShow == true) {
      await this.$nextTick(() => {
        this.drawSoTrend();
      });
    }

    await this.drawMoTrend();

    this.threadLoading = false;
    this.moduleLoading = false;
    this.soTrendLoading = false;
    await dispatchDeepPerformanceCpuCpuFunctionOverview(store, {
      project: this.localProject,
      date: date,
      old_date: old_date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      old_version: old_version,
      id_test: this.id_test,
      old_test: old_test,
    });
    await dispatchDeepPerformanceCpuUsageList(store, {
      project: this.localProject,

      id_test: this.id_test,
      old_test: old_test,
      fps_rate: "",
    });
    await this.overviewHead();
    this.functiontableLoading = false;
    await dispatchDeepPerformanceCpuCpuFunction(store, {
      project: this.localProject,
      date: date,
      old_date: old_date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      old_version: old_version,
      id_test: this.id_test,
      thread: this.dataConsumeOptions.thread,
      label: this.dataConsumeOptions.subScene,
      old_test: old_test,
    });

    this.functionNameLoading = false;
    this.startValue = 0;
    this.endValue = 100;

    (this.selectShow = false), //控制框选文字
      (this.currentPage = 1);
    this.coordRange = []; //
    this.trendInex = 0;
    this.serch = "";
    this.makLineShow = true;
    await dispatchDeepPerformanceCpuCpuByFrame(store, {
      project: this.localProject,
      date: date1,
      device_id: Number(this.trendDataOptions.device),
      scene_id: Number(this.trendDataOptions.scene),
      version: version,
      id_test: this.new_id_test,
      thread: this.dataConsumeOptions.thread,
    });
    dispatchDeepPerformanceFlameGraphUrl(store, {
      project: this.localProject,
      id_test: Number(readGetdeepCpuByFrame(store).id_test),
    });
    dispatchDeepPerformancefuncList(store, {
      project: this.localProject,
      id_test: Number(readGetdeepCpuByFrame(store).id_test),
    });
    await this.labels;
    this.series();
    this.legendData();
    await this.$nextTick(() => {
      this.drawAnalyseTrend();
    });
    this.overall();
    this.getFramesInfo(this.trendInex, this.trendInex);
    this.selectData(this.trendInex);
    this.functionNameTrend = false;
    // await dispatchDeepPerformanceCpuStackCreated(store, {
    //   project: this.localProject,
    //   id_test: Number(readGetdeepCpuByFrame(store).id_test),
    // frame:  this.cpu_by_frame.frame_index[0],
    //   depth:0,
    //   id_row:'',
    //   thread:this.lastThread,
    //     abs_time:this.cpu_by_frame.abs_time[0]
    // });
    this.testShow = false;

    await dispatchDeepPerformanceCpuStack(store, {
      project: this.localProject,
      id_test: Number(readGetdeepCpuByFrame(store).id_test),
      frame: this.cpu_by_frame.frame_index[0],

      thread: this.threadTrendOptions,
    });
    this.testShow = true;
    // let c = (this.$refs.iframeDom as any).contentWindow;
    // let iframe: any = document.getElementById("bdIframe");
    // c.postMessage(
    //   {
    //     cmd: JSON.stringify(this.stackData_obj),
    //     apiUrl: 3,
    //     params: {},
    //   },
    //   "*"
    // ),
    //   window.addEventListener("message", (e) => {
    //     let data = e.data;

    //     iframe.height = Number(data.c) + 20 + "px";
    //   }),
    this.activeNames = [];
    this.tableList_storage = [];
    this.tree_storage = [];
    this.flame_storage = [];
    //     this.tableList = this.get
    //     this.tableList = this.getTop10(this.stackData_obj).slice(1);
    //     this.tableList.forEach((v) => {
    //             let found = false;
    //             this.series_list.forEach((item) => {
    //               if (v.id == item.id) {
    //                 v.check = true;
    //                 found = true;
    //                 return false; // 跳出循环
    //               }
    //               if (!found) {
    //                 v.check = false;
    //               }
    //             });
    //           });
    //              this.stackData_all.forEach(v=>{
    //             this.updateCheckProperty(v, this.series_list);
    //           });
    //            (this.$refs.table as any).toggleRowExpansion(
    //             this.stackData_all[0],
    //             true
    //           );
    //       let names = this.tableList.map(item => item.id);
    // const result = Object.entries(this.func_list).filter(([key, value]) => !names.includes(key));

    // // 将结果转换为对象
    // const filteredObj :any= Object.fromEntries(result);
    //    for(let i in  this.func_list){
    //      this.tableList.forEach(v=>{
    //        if(v.id===i){
    //          v.average_value=this.func_list[i].value
    //          v.difference=(v.time- v.average_value).toFixed(2)
    //        }

    //      })
    //    }
    //    for (let i in  filteredObj){
    //      if( filteredObj[i].name!='FrameTime'){
    // this.tableList.push({name:filteredObj[i].name,id:i,time:0,rate:0,average_value:filteredObj[i].value,difference:0-filteredObj[i].value,check:false})
    //      }

    //    }
    //     this.tableList_new = this.tableList.slice(
    //       (this.currentPage - 1) * 10,
    //       this.currentPage * 10
    //     );
    //     if (this.testShow == true) {
    //       console.log(this.$refs.table as any);

    //     }
    //     this.total = this.tableList.length;
    //     this.renderFlame("#chart", this.stackData_obj);
    this.functionStack = false;
    this.functionStack1 = false;
  }
  public auto_query: any = [];
  public type_query: any = "";
  public subtype_query: any = "";
  public getName(item, i) {
    if (item.indexOf("_") != -1) {
      return item.split("_")[0];
    } else {
      return item;
    }
  }
  public soShow = true;

  public removeBtn(index) {
    let num = "";

    if (
      this.cpu_function_model_list.find(
        (v) => v.value === this.module_list[index].name
      )
    ) {
      num = this.cpu_function_model_list.find(
        (v) => v.value === this.module_list[index].name
      ).label;
      this.disposeOptions.module.splice(
        this.disposeOptions.module.indexOf(num),
        1
      );
    }
    //  if( this.disposeOptions.module.indexOf(this.module_list[index].name)!=-1){
    //   num= this.disposeOptions.module.indexOf(this.module_list[index].name)
    //   this.disposeOptions.module.splice(num,1)
    //  }

    this.module_list.splice(index, 1);
  }

  public find = (v, list) => {
    let data;
    (list || []).map((i) => {
      if (i.id === v) {
        if (i.children) {
          data = i.children;
          data.forEach((m) => {
            if (m.children.length > 0) {
              m.is_expand = true;
            } else {
              m.is_expand = false;
            }
          });
        }

        // data.map(e => { delete e.children })
      } else {
        const child = this.find(v, i.children);

        if (child) {
          data = child;
        }
      }
    });

    return data;
  };
  public expanded() {
    const els = document.getElementsByClassName(
      "el-table__expand-icon el-table__expand-icon--expanded"
    );
    console.log(els);
    this.$nextTick(() => {
      (els[0] as any)?.click();
    });
  }
  public async load(
    row: any,
    treeNode: unknown,
    resolve: (date: any[]) => void
  ) {
    // this.find(row.id,this.stackData_all)
    // await dispatchDeepPerformanceCpuStackCreatedOld(store,{
    //     project: this.localProject,
    //   id_test: Number(readGetdeepCpuByFrame(store).id_test),
    //   frame: this.abs_time,
    //   depth:row.depth,
    //   id_row:row.id_row,
    //   thread:row.thread_hash_id,
    //   abs_time:this.month,
    // })
    //  let childrenListArray = readGetdeepCpuStackCreatOld(store);
    await setTimeout(() => {
      resolve(this.find(row.id, this.stackData_all));
    }, 1000);
  }
  public testShow = true;
  public module_list = [{ name: "", value: [] }];
  // public async disposeChange(num) {
  //   if (num == "1") {
  //    (this.disposeOptions.so = []);
  //     await dispatchDeepPerformanceCpuFunctionCos(store, {
  //       project: this.localProject,
  //       threads: this.disposeOptions.thread,
  //       id_test: this.$route.query.id_test,
  //     });
  //     await dispatchDeepPerformanceCpuFunctionModel(store, {
  //       project: this.localProject,
  //       threads: this.disposeOptions.thread,
  //       sos: '',
  //       id_test: this.$route.query.id_test,
  //     });
  //   }
  //   if (num == "2") {
  //     // this.disposeOptions.module = [];
  //     await dispatchDeepPerformanceCpuFunctionModel(store, {
  //       project: this.localProject,
  //       threads: this.disposeOptions.thread,
  //       sos: '',
  //       id_test: this.$route.query.id_test,
  //     });
  //   }
  //   if (num == "3") {
  //     let list=[]
  //     this.module_list=[]
  //     this.cpu_function_model_list.forEach(v=>{
  //       this.disposeOptions.module.forEach(k=>{
  //         if(v.label==k){
  //           list.push(v.value)
  //         }
  //       })
  //     })
  //     list.forEach(v=>{
  //       this.module_list.push({
  //         name:v,
  //         value:[]
  //       })
  //     })
  //   }
  //   await this.cpu_function_cos;
  //   await this.cpu_function_model;
  // }
  public cellStyle({ row, column, rowIndex, columnIndex }) {
    //指定坐标rowIndex ：行，columnIndex ：列
    // this.getTableColor(row.depth)
    return "background:" + this.getTableColor(row.depth); //rgb(105,0,7)
  }
  public setCheckFalseExceptId(data, id) {
    data.forEach((item) => {
      if (item.id !== id) {
        item.check = false;
      }
    });
  }
  public get sub_data() {
    let list = [];
    if (this.type_query == 13) {
      list = [
        { name: "局内", value: "0" },
        { name: "局外", value: "1" },
      ];
    } else if (this.type_query == 9) {
      list = [
        { name: "Default", value: "0" },
        { name: "开profile", value: "1" },
        { name: "关profile", value: "2" },
      ];
    } else {
      list = [{ name: "Default", value: "0" }];
    }
    return list;
  }

  public get report_data() {
    let list = [];
    let falseArray: any = [36, 34, 40, 47, 12, 32, 4];
    if (
      this.localProject === 34 ||
      this.localProject === 40 ||
      this.localProject === 47
    ) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
      ];
    }
    if (this.localProject === 32) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤异常测试", value: 13 },
      ];
    }
    if (this.localProject === 36) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤测试报告", value: 5 },
        { name: "UI性能测试报告", value: 25 },
      ];
    }
    if (this.localProject === 4) {
      list = [
        { name: "Default", value: 0 },
        { name: "分支性能", value: 21 },
        { name: "主干性能", value: 22 },
        { name: "分支dev", value: 23 },
        { name: "主干dev", value: 24 },
        { name: "登录测试", value: 30 },
        { name: "iOS登录", value: 41 },
      ];
    }
    if (this.localProject === 12) {
      list = [{ name: "Default", value: 0 }];
    } else if (falseArray.every((v) => v != this.localProject)) {
      list = [{ name: "Default", value: 0 }];
    }

    return list;
  }
  public sub_key = 0;
  public handleChangeRow(data, id, check) {
    if (check) {
      this.setCheckFalseExceptId(data, id);
      this.sub_key++;
    }
  }
  public get detail_test() {
    return readDeepPerformancePageList(store).results;
  }
  public async cpu_tree_btn() {
    // console.log(this.type_data.filter(v=>v.check==true))
    //  this.auto_query=this.auto_data.filter(v=>v.check==true).length>0?this.auto_data.filter(v=>v.check==true)[0].id:''
    //       this.type_query=this.type_data.filter(v=>v.check==true).length>0?this.type_data.filter(v=>v.check==true)[0].id:''
    //       this.subtype_query=this.sub_data.filter(v=>v.check==true).length>0?this.sub_data.filter(v=>v.check==true)[0].id:''

    this.threadLoading = true;
    this.cpuTrendLoading = true;
    this.functionNameLoading = true;
    this.moduleLoading = true;
    this.soTrendLoading = true;
    this.functiontableLoading = true;
    this.functionNameTrend = true;
    this.functionStack = true;
    this.functionStack1 = true;
    // await dispatchGetMyProjects(store);
    // this.renderFlame("#chart", this.ojb);

    // await dispatchGetProjectDetail(store, {
    //   id: this.localProject,
    //   project: this.localProject,
    // });
    // await dispatchDeepPerformanceCpuCpuConfig(store, {
    //   project: this.localProject,
    // });
    //  if (this.$route.query.game_version){
    //     if(this.localProject==7){
    //          this.auto_query=this.$route.query.auto
    //           this.type_query=this.$route.query.type
    //           this.subtype_query=this.$route.query.subtype
    //          this. setCheckTrueById(this.auto_data, this.auto_query)
    //          this. setCheckTrueById(this.type_data, this.type_query)
    //          this. setCheckTrueById(this.sub_data, this.subtype_query)
    //       }
    //  }

    await Promise.all([
      dispatchDeepPerformanceCpuCpuVersions(store, {
        project: this.localProject,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      }),
    ]);

    if (this.versionsOptions.length == 0) {
      return;
    } else {
      this.dataConsumeOptions.version = this.versionsOptions[0].chinese;
      this.trendDataOptions.version = this.versionsOptions[0].chinese;

      let date_func = this.versionsOptions.filter(
        (v) => v.chinese == this.trendDataOptions.version
      )[0].date;

      let version_func = this.versionsOptions.filter(
        (v) => v.chinese == this.trendDataOptions.version
      )[0].game_version;
      await dispatchGetDeepPerformanceSelectOptions(store, {
        project: this.localProject,
        date: date_func,
        game_version: version_func,
      }),
        await this.performace_select_options;
      await this.lastDeviceOptions();
      await this.lastSceneOptions();
      this.dataOptions.device = this.device_options[0].device_id;
      this.dataOptions.scene = this.scene_options[0].scene_id;
      this.trendData.device = this.device_options[0].device_id;
      this.trendData.scene = this.scene_options[0].scene_id;

      this.dataOptions.device = this.device_options[0].device_id;
      this.trendData.device = this.device_options[0].device_id;
      this.dataConsumeOptions.device = this.device_options[0].device_id;
      this.dataOptions.scene = this.scene_options[0].scene_id;
      this.trendData.scene = this.scene_options[0].scene_id;
      this.trendDataOptions.device = this.device_options[0].device_id;
      this.trendDataOptions.scene = this.scene_options[0].scene_id;
      let id_test_list = this.versionsOptions[0].id_test;

      this.dataConsumeOptions.scene = this.scene_options[0].scene_id;
      (this.dataConsumeOptions as any).id_test = id_test_list;
      (this.id_test as any) = id_test_list;
      (this.new_id_test as any) = id_test_list;
      await dispatchDeepPerformanceCpuDetail(store, {
        project: this.localProject,
        id_test: this.dataConsumeOptions.id_test,
      });
      dispatchDeepPerformanceCpuUsageTrend(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.trendData.device),
        scene_id: Number(this.trendData.scene),
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      }).then((res) => {
        this.drawCpuTrend();
        this.cpuTrendLoading = false;
      });
      dispatchDeepPerformanceFlameGraphUrl(store, {
        project: this.localProject,
        id_test: this.id_test,
      });
      dispatchDeepPerformancefuncList(store, {
        project: this.localProject,
        id_test: this.id_test,
      });
      await Promise.all([
        dispatchDeepPerformanceCpuLabels(store, {
          project: this.localProject,
          start: "",
          end: "",
          device_id: Number(this.dataOptions.device),
          scene_id: Number(this.dataOptions.scene),
          id_test: this.id_test,
        }),

        dispatchDeepPerformanceCpuCpuVersionsOld(store, {
          project: this.localProject,
          device_id: Number(this.dataConsumeOptions.device),
          scene_id: Number(this.dataConsumeOptions.scene),
          is_auto: this.auto_query,
          type: this.type_query,
          subtype: this.subtype_query,
        }),
      ]);
      if (this.detail) {
        let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);

        this.report_settings_threshold = report_settings.threshold.change;
        this.report_settings_threshold_abs = report_settings.threshold.abs;
        this.soShow = report_settings.show_so === 0 ? false : true;
        // this.soShow=false
        // 趋势图列表默认
        this.report_settings = report_settings.show;

        if (JSON.stringify(report_settings) === "{}") {
          await dispatchDeepPerformanceCpuCpuThreads(store, {
            project: this.localProject,

            id_test: this.dataConsumeOptions.id_test,
          });

          (this.trendOptions.thread = ""),
            (this.dataConsumeOptions.thread = "");
          this.trendOptions.so = "";
          // 如果无数据的逻辑 此代码与运行无关 以防备用
        } else {
          this.threadShow =
            report_settings.module.is_show_all === 1 ? false : true;
          this.custom_json = readGetdeepCpuDetail(store).settings;
          // this.report_settings = { top: 5 };

          if (
            Object.keys(this.report_settings).length === 1 &&
            Object.keys(this.report_settings)[0] == "top"
          ) {
            this.threadchange = true;
            await dispatchDeepPerformanceCpuCpuThreads(store, {
              project: this.localProject,

              id_test: this.dataConsumeOptions.id_test,
            });
            let reportLength = 0;
            reportLength =
              this.report_settings.top < this.threadOptions.length
                ? this.report_settings.top
                : this.threadOptions.length;

            for (let i = 0; i < reportLength; i++) {
              this.threadOldOptions.push(this.threadOptions[i]);
              this.threadTrendOptions.push(this.threadOptions[i]);
            }

            this.trendOptions.thread = this.threadTrendOptions[0];
            this.trendOptions.thread1 = this.threadTrendOptions[0];
            this.lastThread = this.threadOldOptions[0];
            this.dataConsumeOptions.thread = this.threadOldOptions[0];
            await dispatchDeepPerformanceCpuFunctionCos(store, {
              project: this.localProject,
              thread: this.trendOptions.thread,
              id_test: this.dataConsumeOptions.id_test,
            });

            for (
              let i = 0;
              i <
              (this.cpu_function_cos.length >= 5
                ? 5
                : this.cpu_function_cos.length);
              i++
            ) {
              this.soTrendOptions.push(this.cpu_function_cos[i]);
            }
            this.trendOptions.so = this.soTrendOptions[0];
          }
          if (Object.keys(this.report_settings).length > 1) {
            this.threadchange = false;
            this.threadTrendOptions = Object.keys(this.report_settings);
            this.threadOldOptions = Object.keys(this.report_settings);
            if (this.threadTrendOptions.indexOf("top") != -1) {
              this.threadTrendOptions.splice(
                this.threadTrendOptions.indexOf("top"),
                1
              );
              this.threadOldOptions.splice(
                this.threadOldOptions.indexOf("top"),
                1
              );
            }
            this.trendOptions.thread = this.threadTrendOptions[0];
            this.trendOptions.thread1 = this.threadTrendOptions[0];
            this.lastThread = this.threadOldOptions[0];
            this.dataConsumeOptions.thread = this.threadOldOptions[0];
            if (
              Object.keys(this.report_settings[this.trendOptions.thread])
                .length == 1 &&
              Object.keys(this.report_settings[this.trendOptions.thread])[0] ===
                "top"
            ) {
              this.sochange = true;
              await dispatchDeepPerformanceCpuFunctionCos(store, {
                project: this.localProject,
                thread: this.trendOptions.thread,
                id_test: this.dataConsumeOptions.id_test,
              });
              let reportLength = 0;
              reportLength =
                this.report_settings[this.trendOptions.thread].top <
                this.cpu_function_cos.length
                  ? this.report_settings[this.trendOptions.thread].top
                  : this.cpu_function_cos.length;
              for (let i = 0; i < reportLength; i++) {
                this.soTrendOptions.push(this.cpu_function_cos[i]);
              }
              this.trendOptions.so = this.soTrendOptions[0];
            }
            if (
              Object.keys(this.report_settings[this.trendOptions.thread])
                .length > 1
            ) {
              this.sochange = false;
              this.soTrendOptions = Object.keys(
                this.report_settings[this.trendOptions.thread]
              );
              if (this.soTrendOptions.indexOf("top") != -1) {
                this.soTrendOptions.splice(
                  this.soTrendOptions.indexOf("top"),
                  1
                );
                // this.threadOldOptions.splice(this.threadOldOptions.indexOf('top'),1)
              }
              this.trendOptions.so =
                this.soTrendOptions.length > 0 ? this.soTrendOptions[0] : "";
            }
          }
        }
      }

      this.dataOptions.subScene = this.subScene[0].lable_name;
      // this.dataConsumeOptions.old_verson =
      //   this.versionsOldOptions.length > 1
      //     ? this.versionsOldOptions[1].chinese
      //     : this.versionsOldOptions[0].chinese;
      if (this.versionsOldOptions.length == 1) {
        this.dataConsumeOptions.old_verson = this.versionsOldOptions[0].chinese;
      }
      if (this.versionsOldOptions.length > 1) {
        let index = this.versionsOldOptions.findIndex(
          (v) => v.chinese == this.dataConsumeOptions.version
        );
        let index_num = 0;
        if (index == this.versionsOldOptions.length - 1) {
          index_num = index - 1;
        } else {
          index_num = index + 1;
        }

        this.dataConsumeOptions.old_verson = this.versionsOldOptions[
          index_num
        ].chinese;
      }
      // this.dataConsumeOptions.old_test =
      //   this.versionsOldOptions.length > 1
      //     ? this.versionsOldOptions[1].id_test
      //     : this.versionsOldOptions[0].id_test;
      // let threadLength = Object.keys(this.threadOptions).length;

      let date = this.versionsOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].date;

      let version = this.versionsOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.version
      )[0].game_version;
      let old_date = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].date;
      let old_version = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].game_version;
      let old_test = this.versionsOldOptions.filter(
        (v) => v.chinese == this.dataConsumeOptions.old_verson
      )[0].id_test;
      await dispatchGetDeepPerformanceSelectOptionsOld(store, {
        project: this.localProject,
        date: date,
        game_version: version,
      });
      await dispatchDeepPerformanceCpuLabelsOld(store, {
        project: this.localProject,
        date: date,
        version: version,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
      });
      this.dataConsumeOptions.subScene = this.subSceneOld[0]?.lable_name;
      // if (this.disposeOptions.thread.length == 0) {
      //   this.dataConsumeOptions.thread = "";
      //   this.lastThread = "";
      //   this.threadOldOptions = [];
      // } else {
      //   this.dataConsumeOptions.thread = this.disposeOptions.thread[0];
      //   this.lastThread = this.disposeOptions.thread[0];
      //   this.threadOldOptions = readGetdeepCpuThreads(store).data.filter((v) => {
      //     return this.disposeOptions.thread.includes(v.label);
      //   });
      //   console.log(this.threadOldOptions);
      // }
      // if (this.threadOptions.length >= 4) {
      //   // threadKey.forEach((v) => {
      //   //   this.dataOptions.thread.push(this.threadOptions[v]);
      //   // });
      //   for (let i = 0; i <= 5; i++) {
      //     this.dataOptions.thread.push(this.threadOptions[i].label);
      //   }
      // }

      await dispatchDeepPerformanceCpuCpuTrend(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),
        threads: this.threadTrendOptions,
        label: this.dataOptions.subScene,
        id_test: this.dataConsumeOptions.id_test,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      });
      if (this.soShow == true) {
        await dispatchDeepPerformanceCpuCpuSoTrend(store, {
          project: this.localProject,
          start: "",
          end: "",
          device_id: Number(this.dataOptions.device),
          scene_id: Number(this.dataOptions.scene),
          thread: this.trendOptions.thread,
          label: this.dataOptions.subScene,
          id_test: this.dataConsumeOptions.id_test,
        });
      }

      await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),

        label: this.dataOptions.subScene,

        id_test: this.dataConsumeOptions.id_test,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      });

      this.threadName = this.thrend_data.thread_list[0];

      this.soTrendShow = true;
      await this.drawThreadTrend();
      if (this.soShow == true) {
        await this.drawSoTrend();
      }

      await this.drawMoTrend();

      this.threadLoading = false;
      this.moduleLoading = false;
      this.soTrendLoading = false;

      await dispatchDeepPerformanceCpuCpuFunctionOverview(store, {
        project: this.localProject,
        date: date,
        old_date: old_date,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        version: version,
        old_version: old_version,
        id_test: this.id_test,
        old_test: old_test,
      });
      await dispatchDeepPerformanceCpuUsageList(store, {
        project: this.localProject,

        id_test: this.id_test,
        old_test: old_test,
        fps_rate: "",
      });
      await this.overviewHead();
      this.functiontableLoading = false;
      await dispatchDeepPerformanceCpuCpuFunction(store, {
        project: this.localProject,
        date: date,
        old_date: old_date,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        version: version,
        old_version: old_version,
        id_test: this.id_test,
        thread: this.dataConsumeOptions.thread,
        label: this.dataConsumeOptions.subScene,
        old_test: old_test,
      });

      this.functionNameLoading = false;
      await dispatchDeepPerformanceCpuCpuByFrame(store, {
        project: this.localProject,
        date: date,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        version: version,
        id_test: this.id_test,
        thread: this.dataConsumeOptions.thread,
      });

      await this.labels;
      this.series();

      this.legendData();
      await this.$nextTick(() => {
        this.drawAnalyseTrend();
      });
      this.overall();
      this.getFramesInfo(this.trendInex, this.trendInex);
      this.selectData(this.trendInex);
      this.functionNameTrend = false;

      this.testShow = false;
      await dispatchDeepPerformanceCpuStack(store, {
        project: this.localProject,
        id_test: Number(this.id_test),
        frame: 0,

        thread: this.threadTrendOptions,
      });
      this.testShow = true;
      this.functionStack = false;

      if (this.testShow == true) {
        console.log(this.$refs.table as any);
      }

      this.functionStack1 = false;
    }
  }
  public report_settings: any = {};
  public threadOldOptions = [];
  public async mounted() {
    this.threadLoading = true;
    this.cpuTrendLoading = true;
    this.functionNameLoading = true;
    this.moduleLoading = true;
    this.soTrendLoading = true;
    this.functiontableLoading = true;
    this.functionNameTrend = true;
    this.functionStack = true;
    this.functionStack1 = true;
    // await dispatchGetMyProjects(store);
    // this.renderFlame("#chart", this.ojb);

    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    await dispatchDeepPerformanceCpuCpuConfig(store, {
      project: this.localProject,
    });
    if (this.$route.query.game_version) {
      this.auto_query.push(Number(this.$route.query.auto));

      //  this.auto_query=this.$route.query.auto
      this.type_query = Number(this.$route.query.type);
      this.subtype_query = this.$route.query.subtype;
      //  this. setCheckTrueById(this.auto_data, this.auto_query)
      //  this. setCheckTrueById(this.type_data, this.type_query)
      //  this. setCheckTrueById(this.sub_data, this.subtype_query)
    }

    await Promise.all([
      dispatchDeepPerformanceCpuCpuVersions(store, {
        project: this.localProject,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      }),
    ]);

    if (this.$route.query.game_version) {
      this.versionsOptions.forEach((v) => {
        if (
          v.id_test == this.$route.query.id_test &&
          v.game_version == this.$route.query.game_version
        ) {
          this.dataConsumeOptions.version = v.chinese;
          this.trendDataOptions.version = v.chinese;
        }
      });
    } else {
      this.dataConsumeOptions.version = this.versionsOptions[0].chinese;
      this.trendDataOptions.version = this.versionsOptions[0].chinese;
    }

    let date_func = this.versionsOptions.filter(
      (v) => v.chinese == this.trendDataOptions.version
    )[0].date;

    let version_func = this.versionsOptions.filter(
      (v) => v.chinese == this.trendDataOptions.version
    )[0].game_version;
    await dispatchGetDeepPerformanceSelectOptions(store, {
      project: this.localProject,
      date: date_func,
      game_version: version_func,
    }),
      await this.performace_select_options;
    await this.lastDeviceOptions();
    await this.lastSceneOptions();
    this.dataOptions.device = this.device_options[0].device_id;
    this.dataOptions.scene = this.scene_options[0].scene_id;
    this.trendData.device = this.device_options[0].device_id;
    this.trendData.scene = this.scene_options[0].scene_id;

    this.dataOptions.device = this.$route.query.device_id
      ? Number(this.$route.query.device_id)
      : this.device_options[0].device_id;
    this.trendData.device = this.$route.query.device_id
      ? Number(this.$route.query.device_id)
      : this.device_options[0].device_id;
    this.dataConsumeOptions.device = this.$route.query.device_id
      ? Number(this.$route.query.device_id)
      : this.device_options[0].device_id;
    this.dataOptions.scene = this.$route.query.scene
      ? Number(this.$route.query.scene)
      : this.scene_options[0].scene_id;
    this.trendData.scene = this.$route.query.scene
      ? Number(this.$route.query.scene)
      : this.scene_options[0].scene_id;
    this.trendDataOptions.device = this.$route.query.device_id
      ? Number(this.$route.query.device_id)
      : this.device_options[0].device_id;
    this.trendDataOptions.scene = this.$route.query.scene
      ? Number(this.$route.query.scene)
      : this.scene_options[0].scene_id;
    let id_test_list = 0;
    if (!this.$route.query.id_test) {
      await dispatchGetDeepPerformancePageList(store, {
        project: this.localProject,
        scene_id_list: [],
        device_id_list: [],
        game_versions: [],
        page: 1,
        size: "",
      });
      id_test_list = this.detail_test.filter((v: any) => v.status === 5)[0]
        .id_test;
    }
    this.dataConsumeOptions.scene = this.$route.query.scene
      ? Number(this.$route.query.scene)
      : this.scene_options[0].scene_id;
    (this.dataConsumeOptions as any).id_test = this.$route.query.id_test
      ? this.$route.query.id_test
      : id_test_list;
    (this.id_test as any) = this.$route.query.id_test
      ? this.$route.query.id_test
      : id_test_list;
    (this.new_id_test as any) = this.$route.query.id_test
      ? this.$route.query.id_test
      : id_test_list;
    await dispatchDeepPerformanceCpuDetail(store, {
      project: this.localProject,
      id_test: this.dataConsumeOptions.id_test,
    });
    dispatchDeepPerformanceCpuUsageTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: Number(this.trendData.device),
      scene_id: Number(this.trendData.scene),
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    }).then((res) => {
      this.drawCpuTrend();
      this.cpuTrendLoading = false;
    });
    dispatchDeepPerformanceFlameGraphUrl(store, {
      project: this.localProject,
      id_test: this.id_test,
    });
    dispatchDeepPerformancefuncList(store, {
      project: this.localProject,
      id_test: this.id_test,
    });
    await Promise.all([
      dispatchDeepPerformanceCpuLabels(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),
        id_test: this.id_test,
      }),

      dispatchDeepPerformanceCpuCpuVersionsOld(store, {
        project: this.localProject,
        device_id: Number(this.dataConsumeOptions.device),
        scene_id: Number(this.dataConsumeOptions.scene),
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      }),
    ]);
    if (this.detail) {
      let report_settings = JSON.parse(readGetdeepCpuDetail(store).settings);

      this.report_settings_threshold = report_settings.threshold.change;
      this.report_settings_threshold_abs = report_settings.threshold.abs;
      this.soShow = report_settings.show_so === 0 ? false : true;
      // this.soShow=false
      // 趋势图列表默认
      this.report_settings = report_settings.show;

      if (JSON.stringify(report_settings) === "{}") {
        await dispatchDeepPerformanceCpuCpuThreads(store, {
          project: this.localProject,

          id_test: this.dataConsumeOptions.id_test,
        });

        (this.trendOptions.thread = ""), (this.dataConsumeOptions.thread = "");
        this.trendOptions.so = "";
        // 如果无数据的逻辑 此代码与运行无关 以防备用
      } else {
        this.threadShow =
          report_settings.module.is_show_all === 1 ? false : true;
        this.custom_json = readGetdeepCpuDetail(store).settings;
        // this.report_settings = { top: 5 };

        if (
          Object.keys(this.report_settings).length === 1 &&
          Object.keys(this.report_settings)[0] == "top"
        ) {
          this.threadchange = true;
          await dispatchDeepPerformanceCpuCpuThreads(store, {
            project: this.localProject,

            id_test: this.dataConsumeOptions.id_test,
          });
          let reportLength = 0;
          reportLength =
            this.report_settings.top < this.threadOptions.length
              ? this.report_settings.top
              : this.threadOptions.length;

          for (let i = 0; i < reportLength; i++) {
            this.threadOldOptions.push(this.threadOptions[i]);
            this.threadTrendOptions.push(this.threadOptions[i]);
          }

          this.trendOptions.thread = this.threadTrendOptions[0];
          this.trendOptions.thread1 = this.threadTrendOptions[0];
          this.lastThread = this.threadOldOptions[0];
          this.dataConsumeOptions.thread = this.threadOldOptions[0];
          await dispatchDeepPerformanceCpuFunctionCos(store, {
            project: this.localProject,
            thread: this.trendOptions.thread,
            id_test: this.dataConsumeOptions.id_test,
          });

          for (
            let i = 0;
            i <
            (this.cpu_function_cos.length >= 5
              ? 5
              : this.cpu_function_cos.length);
            i++
          ) {
            this.soTrendOptions.push(this.cpu_function_cos[i]);
          }
          this.trendOptions.so = this.soTrendOptions[0];
        }
        if (Object.keys(this.report_settings).length > 1) {
          this.threadchange = false;
          this.threadTrendOptions = Object.keys(this.report_settings);
          this.threadOldOptions = Object.keys(this.report_settings);
          if (this.threadTrendOptions.indexOf("top") != -1) {
            this.threadTrendOptions.splice(
              this.threadTrendOptions.indexOf("top"),
              1
            );
            this.threadOldOptions.splice(
              this.threadOldOptions.indexOf("top"),
              1
            );
          }
          this.trendOptions.thread = this.threadTrendOptions[0];
          this.trendOptions.thread1 = this.threadTrendOptions[0];
          this.lastThread = this.threadOldOptions[0];
          this.dataConsumeOptions.thread = this.threadOldOptions[0];
          if (
            Object.keys(this.report_settings[this.trendOptions.thread])
              .length == 1 &&
            Object.keys(this.report_settings[this.trendOptions.thread])[0] ===
              "top"
          ) {
            this.sochange = true;
            await dispatchDeepPerformanceCpuFunctionCos(store, {
              project: this.localProject,
              thread: this.trendOptions.thread,
              id_test: this.dataConsumeOptions.id_test,
            });
            let reportLength = 0;
            reportLength =
              this.report_settings[this.trendOptions.thread].top <
              this.cpu_function_cos.length
                ? this.report_settings[this.trendOptions.thread].top
                : this.cpu_function_cos.length;
            for (let i = 0; i < reportLength; i++) {
              this.soTrendOptions.push(this.cpu_function_cos[i]);
            }
            this.trendOptions.so = this.soTrendOptions[0];
          }
          if (
            Object.keys(this.report_settings[this.trendOptions.thread]).length >
            1
          ) {
            this.sochange = false;
            this.soTrendOptions = Object.keys(
              this.report_settings[this.trendOptions.thread]
            );
            if (this.soTrendOptions.indexOf("top") != -1) {
              this.soTrendOptions.splice(this.soTrendOptions.indexOf("top"), 1);
              // this.threadOldOptions.splice(this.threadOldOptions.indexOf('top'),1)
            }
            this.trendOptions.so =
              this.soTrendOptions.length > 0 ? this.soTrendOptions[0] : "";
          }
        }
      }
    }

    this.dataOptions.subScene = this.subScene[0].lable_name;
    // this.dataConsumeOptions.old_verson =
    //   this.versionsOldOptions.length > 1
    //     ? this.versionsOldOptions[1].chinese
    //     : this.versionsOldOptions[0].chinese;
    if (this.versionsOldOptions.length == 1) {
      this.dataConsumeOptions.old_verson = this.versionsOldOptions[0].chinese;
    }
    if (this.versionsOldOptions.length > 1) {
      let index = this.versionsOldOptions.findIndex(
        (v) => v.chinese == this.dataConsumeOptions.version
      );
      let index_num = 0;
      if (index == this.versionsOldOptions.length - 1) {
        index_num = index - 1;
      } else {
        index_num = index + 1;
      }

      this.dataConsumeOptions.old_verson = this.versionsOldOptions[
        index_num
      ].chinese;
    }
    // this.dataConsumeOptions.old_test =
    //   this.versionsOldOptions.length > 1
    //     ? this.versionsOldOptions[1].id_test
    //     : this.versionsOldOptions[0].id_test;
    // let threadLength = Object.keys(this.threadOptions).length;

    let date = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].date;

    let version = this.versionsOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.version
    )[0].game_version;
    let old_date = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].date;
    let old_version = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].game_version;
    let old_test = this.versionsOldOptions.filter(
      (v) => v.chinese == this.dataConsumeOptions.old_verson
    )[0].id_test;
    await dispatchGetDeepPerformanceSelectOptionsOld(store, {
      project: this.localProject,
      date: date,
      game_version: version,
    });
    await dispatchDeepPerformanceCpuLabelsOld(store, {
      project: this.localProject,
      date: date,
      version: version,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
    });
    this.dataConsumeOptions.subScene = this.subSceneOld[0]?.lable_name;

    await dispatchDeepPerformanceCpuCpuTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: Number(this.dataOptions.device),
      scene_id: Number(this.dataOptions.scene),
      threads: this.threadTrendOptions,
      label: this.dataOptions.subScene,
      id_test: this.dataConsumeOptions.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });
    if (this.soShow == true) {
      await dispatchDeepPerformanceCpuCpuSoTrend(store, {
        project: this.localProject,
        start: "",
        end: "",
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),
        thread: this.trendOptions.thread,
        label: this.dataOptions.subScene,
        id_test: this.dataConsumeOptions.id_test,
      });
    }

    await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
      project: this.localProject,
      start: "",
      end: "",
      device_id: Number(this.dataOptions.device),
      scene_id: Number(this.dataOptions.scene),

      label: this.dataOptions.subScene,

      id_test: this.dataConsumeOptions.id_test,
      is_auto: this.auto_query,
      type: this.type_query,
      subtype: this.subtype_query,
    });

    this.threadName = this.thrend_data.thread_list[0];

    this.soTrendShow = true;
    await this.drawThreadTrend();
    if (this.soShow == true) {
      await this.drawSoTrend();
    }

    await this.drawMoTrend();

    this.threadLoading = false;
    this.moduleLoading = false;
    this.soTrendLoading = false;

    await dispatchDeepPerformanceCpuCpuFunctionOverview(store, {
      project: this.localProject,
      date: date,
      old_date: old_date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      old_version: old_version,
      id_test: this.id_test,
      old_test: old_test,
    });
    await dispatchDeepPerformanceCpuUsageList(store, {
      project: this.localProject,

      id_test: this.id_test,
      old_test: old_test,
      fps_rate: "",
    });
    await this.overviewHead();
    this.functiontableLoading = false;
    await dispatchDeepPerformanceCpuCpuFunction(store, {
      project: this.localProject,
      date: date,
      old_date: old_date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      old_version: old_version,
      id_test: this.id_test,
      thread: this.dataConsumeOptions.thread,
      label: this.dataConsumeOptions.subScene,
      old_test: old_test,
    });

    this.functionNameLoading = false;
    await dispatchDeepPerformanceCpuCpuByFrame(store, {
      project: this.localProject,
      date: date,
      device_id: Number(this.dataConsumeOptions.device),
      scene_id: Number(this.dataConsumeOptions.scene),
      version: version,
      id_test: this.id_test,
      thread: this.dataConsumeOptions.thread,
    });

    await this.labels;
    this.series();

    this.legendData();
    await this.$nextTick(() => {
      this.drawAnalyseTrend();
    });
    this.overall();
    this.getFramesInfo(this.trendInex, this.trendInex);
    this.selectData(this.trendInex);
    this.functionNameTrend = false;

    this.testShow = false;
    await dispatchDeepPerformanceCpuStack(store, {
      project: this.localProject,
      id_test: Number(this.id_test),
      frame: 0,

      thread: this.threadTrendOptions,
    });
    this.testShow = true;
    this.functionStack = false;

    if (this.testShow == true) {
      console.log(this.$refs.table as any);
    }

    this.functionStack1 = false;
  }
  public handleNodeClick(data) {
    if (!data.children) {
      if (data.label == "性能趋势") {
        const targetElement = document.querySelector("#ms_scroll");
        targetElement.scrollIntoView();
      }

      if (data.label == "详细数据") {
        const targetElement = document.querySelector("#thread_scroll");
        targetElement.scrollIntoView();
      }
      if (data.label == "主要模块耗时") {
        const targetElement = document.querySelector("#moudle_scroll");
        targetElement.scrollIntoView();
      }
      if (data.label == "函数耗时") {
        const targetElement = document.querySelector("#func_scroll");
        targetElement.scrollIntoView();
      }
    }
  }
  public trendOptions = {
    thread: "",
    so: "",
    thread1: "",
  };
  public abs_time = 0;
  public labelWallTime = (d, originalColor) => {
    if (this.flame_serch === "") {
      return originalColor;
    } else {
      return d.data.name
        .toUpperCase()
        .indexOf(this.flame_serch.toUpperCase()) != 0
        ? originalColor
        : "#E600E6";
    }
    // return  d.data.name.indexOf(this.flame_serch)!=0?originalColor : "#E600E6"
  };
  public labelTime = (d) => {
    return (
      d.data.name +
      "(" +
      (d.parent == null
        ? "100%"
        : ((d.value / (this.stackData_obj as any).value) * 100).toFixed(2) +
          "%") +
      "," +
      d.value +
      "ms" +
      ")"
    );
  };

  public recordSearch() {
    this.renderFlame("#chart", this.stackData_obj);
  }
  public getTop10(data) {
    const result = [];
    if (data.value) {
      result.push({
        name: data.name,
        time: data.value,
        rate: data.rate,
        difference: 0 - data.value,
        average_value: 0,
        id: data.id,
      });
    }
    if (data.children && data.children.length > 0) {
      data.children.forEach((item) => {
        result.push(...this.getTop10(item));
      });
    }
    result.sort((a, b) => b.time - a.time);
    return result;
  }
  public renderFlame(selector, data) {
    let flame: any = flamegraph();

    flame
      .width(1360)
      .label(this.labelTime)
      .setColorMapper(this.labelWallTime)
      .transitionDuration(1000);
    // .inverted(true);

    flame.onHover((node) => {
      this.func_name = node.data.name;
      this.func_rate = node.data.rate + "%";
    });

    d3.select(selector).datum(data).call(flame);
  }
  public filterHospital(query, item) {
    if (item == "1") {
      this.cpu_function_thread_list = readGetdeepCpuThreads(store).data.filter(
        (v) => {
          return (
            v.value.toUpperCase().includes(query) ||
            v.value.toLowerCase().includes(query) ||
            v.value.includes(query)
          );
        }
      );
    }
    if (item == "2") {
      this.cpu_function_cos_list = readGetdeepCpuFunctionCos(store).data.filter(
        (v) => {
          return (
            v.value.toUpperCase().includes(query) ||
            v.value.toLowerCase().includes(query) ||
            v.value.includes(query)
          );
        }
      );
    }
    if (item == "3") {
      this.cpu_function_model_list = readGetdeepCpuFunctionModel(
        store
      ).data.filter((v) => {
        return (
          v.value.toUpperCase().includes(query) ||
          v.value.toLowerCase().includes(query) ||
          v.value.includes(query)
        );
      });
    }
    if (item == "4") {
      this.cpu_function_thread_list1 = readGetdeepCpuThreads(store).data.filter(
        (v) => {
          return (
            v.value.toUpperCase().includes(query) ||
            v.value.toLowerCase().includes(query) ||
            v.value.includes(query)
          );
        }
      );
    }
  }
  public arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (typeof arr1[i] === "object" && typeof arr2[i] === "object") {
        if (!this.objectsEqual(arr1[i], arr2[i])) {
          return false;
        }
      } else if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }
  public objectsEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false;
    }
    for (let key in obj1) {
      if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
        if (!this.objectsEqual(obj1[key], obj2[key])) {
          return false;
        }
      } else if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  }
  public storage() {
    if (this.activeNames.length > 0) {
      this.activeNames.forEach((v) => {
        if (v.indexOf("1") != -1) {
          this.table_func();
          this.currentPage = 1;

          this.total = this.tableList.length;
          this.tableList_storage.push(1);
        } else {
          this.tableList_storage = [];
        }
        if (v.indexOf("2") !== -1) {
          this.tree_func();
          this.$nextTick(() => {
            (this.$refs.table as any).toggleRowExpansion(
              this.stackData_all[0],
              true
            );
          });
        } else {
          this.tree_storage = [];
        }
        if (v.indexOf("3") !== -1) {
          this.flame_func();
        } else {
          this.flame_storage = [];
        }
      });
    } else {
      this.tableList_storage = [];
      this.flame_storage = [];
      this.tree_storage = [];
    }
  }
  public tableList_storage = [];
  public tree_storage = [];
  public flame_storage = [];
  public async handleChange() {
    if (this.activeNames.length > 0) {
      if (this.activeNames[this.activeNames.length - 1] == "1") {
        if (this.tableList_storage.length == 0) {
          this.table_func();
          this.total = this.tableList.length;
          this.tableList_storage.push(1);
        }
      }
      if (this.activeNames[this.activeNames.length - 1] == "2") {
        if (this.tree_storage.length == 0) {
          await this.tree_func();
          this.$nextTick(() => {
            (this.$refs.table as any).toggleRowExpansion(
              this.stackData_all[0],
              true
            );
          });

          this.tree_storage.push(1);
        }
      }
      if (this.activeNames[this.activeNames.length - 1] == "3") {
        if (this.flame_storage.length == 0) {
          this.flame_func();
          this.flame_storage.push(1);
        }
      }
    }
  }
  public flame_func() {
    this.renderFlame("#chart", this.stackData_obj);
  }
  public tree_func() {
    this.stackData_all = this.stack_data(this.stackData_obj);

    this.stackData_all.forEach((v) => {
      this.updateCheckProperty(v, this.series_list);
    });
  }
  public table_func() {
    this.tableList = this.getTop10(this.stackData_obj).slice(1);
    this.tableList.forEach((v) => {
      let found = false;
      this.series_list.forEach((item) => {
        if (v.id == item.id) {
          v.check = true;
          found = true;
          return false; // 跳出循环
        }
        if (!found) {
          v.check = false;
        }
      });
    });
    let names = this.tableList.map((item) => item.id);
    const result = Object.entries(this.func_list).filter(
      ([key, value]) => !names.includes(key)
    );

    // 将结果转换为对象
    const filteredObj: any = Object.fromEntries(result);

    for (let i in this.func_list) {
      this.tableList.forEach((v) => {
        if (v.id === i) {
          v.average_value = this.func_list[i].value;
          v.difference = (v.time - v.average_value).toFixed(2);
        }
      });
    }
    for (let i in filteredObj) {
      if (filteredObj[i].name != "FrameTime") {
        this.tableList.push({
          name: filteredObj[i].name,
          id: i,
          time: 0,
          rate: 0,
          average_value: filteredObj[i].value,
          difference: 0 - filteredObj[i].value,
          check: false,
        });
      }
    }
    this.currentPage = 1;

    for (let i = 0; i < this.tableList.length; i++) {
      for (let j = i + 1; j < this.tableList.length; j++) {
        if (this.tableList[i].name === this.tableList[j].name) {
          this.tableList[i].time += this.tableList[j].time;
          this.tableList[i].rate += this.tableList[j].rate;
          this.tableList[i].average_value += this.tableList[j].average_value;
          // Merge ids into an array
          if (!Array.isArray(this.tableList[i].id)) {
            this.tableList[i].id = [this.tableList[i].id];
          }
          this.tableList[i].id.push(this.tableList[j].id);
          this.tableList.splice(j, 1);
          j--; // Decrement j to account for the removed element
        }
      }
    }
    this.tableList.forEach((v) => {
      v.time = v.time.toFixed(2);
      v.rate = v.rate.toFixed(2);
      v.average_value = v.average_value.toFixed(4);
      v.difference = (v.time - v.average_value).toFixed(4);
    });
    this.tableList_new = this.tableList.slice(
      (this.currentPage - 1) * 10,
      this.currentPage * 10
    );
    this.total = this.tableList.length;
  }
  public async trendChange(item) {
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.dataOptions.pick !== null) {
      startTimeAll = dateConversion(this.dataOptions.pick[0]);
      endTimeAll = dateConversion(this.dataOptions.pick[1]);
    }

    startTimeAll = startTimeAll === "-" ? "" : startTimeAll;
    endTimeAll = endTimeAll === "-" ? "" : endTimeAll;
    if (this.dataOptions.pick == null) {
      startTimeAll = "";
      endTimeAll = "";
    }
    if (item == "thread") {
      this.soTrendLoading = true;
      if (this.soShow == true) {
        await dispatchDeepPerformanceCpuCpuSoTrend(store, {
          project: this.localProject,
          start: startTimeAll,
          end: endTimeAll,
          device_id: Number(this.dataOptions.device),
          scene_id: Number(this.dataOptions.scene),
          thread: this.trendOptions.thread,
          label: this.dataOptions.subScene,
          id_test: this.$route.query.id_test
            ? this.$route.query.id_test
            : this.detail_test.filter((v: any) => v.status === 5)[0].id_test,
        });
      }

      this.circleflag = true;
      await this.drawThreadTrend();
      if (this.soShow == true) {
        await this.drawSoTrend();
      }
      this.soTrendLoading = false;
      // await this.drawMoTrend();
    }
    if (item == "thread1") {
      this.moduleLoading = true;
      if (this.sochange === false) {
        this.soTrendOptions = Object.keys(
          this.report_settings[this.trendOptions.thread1]
        );
        if (this.soTrendOptions.indexOf("top") != -1) {
          this.soTrendOptions.splice(this.soTrendOptions.indexOf("top"), 1);
          // this.threadOldOptions.splice(this.threadOldOptions.indexOf('top'),1)
        }
        this.trendOptions.so =
          this.soTrendOptions.length > 0 ? this.soTrendOptions[0] : "";
      } else {
        this.soTrendOptions = [];
        await dispatchDeepPerformanceCpuFunctionCos(store, {
          project: this.localProject,
          thread: this.trendOptions.thread1,
          id_test: this.dataConsumeOptions.id_test,
        });
        let reportLength = 0;
        reportLength =
          this.report_settings[this.trendOptions.thread]?.top <
          this.cpu_function_cos.length
            ? this.report_settings[this.trendOptions.thread]?.top
            : this.cpu_function_cos.length;
        for (let i = 0; i < reportLength; i++) {
          this.soTrendOptions.push(this.cpu_function_cos[i]);
        }
        this.trendOptions.so = this.soTrendOptions[0];
      }
      await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
        project: this.localProject,
        start: startTimeAll,
        end: endTimeAll,
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),

        label: this.dataOptions.subScene,

        id_test: this.$route.query.id_test
          ? this.$route.query.id_test
          : this.detail_test.filter((v: any) => v.status === 5)[0].id_test,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      });

      await this.drawMoTrend();

      this.moduleLoading = false;
    }
    if (item == "so") {
      this.moduleLoading = true;
      await dispatchDeepPerformanceCpuFunctionModuleTrend(store, {
        project: this.localProject,
        start: startTimeAll,
        end: endTimeAll,
        device_id: Number(this.dataOptions.device),
        scene_id: Number(this.dataOptions.scene),

        label: this.dataOptions.subScene,

        id_test: this.$route.query.id_test
          ? this.$route.query.id_test
          : this.detail_test.filter((v: any) => v.status === 5)[0].id_test,
        is_auto: this.auto_query,
        type: this.type_query,
        subtype: this.subtype_query,
      });
      this.circleflag = true;
      // await this.drawSoTrend();

      await this.drawMoTrend();

      this.moduleLoading = false;
    }
  }
  public nodeClass(node) {
    return node.level === 1 ? "first-level" : "";
  }
  public circleflag = false;
  public list = [];
  public get labels() {
    this.list = [];
    let num = 0;
    this.cpu_by_frame?.labels?.forEach((v) => {
      num += v.length;
    });
    this.cpu_by_frame?.labels?.forEach((v, index) => {
      this.list.push({
        label: v[0] + "_" + index,
        width: (v.length / num) * 100 + "%",
        color: this.allColorList[index],
      });
    });

    return this.list;
  }
}
